webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(21);



/* harmony default export */ __webpack_exports__["a"] = ({
  priceList: {
    update: function update(id, priceList) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.put('api/price_lists/' + id, priceList);
    },
    get: function get(id) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('api/price_lists/' + id);
    }
  },
  notice: {
    update: function update(id, notice) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.put('api/notices/' + id, notice);
    },
    get: function get(id) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('api/notices/' + id);
    },
    post: function post(data) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post('api/notices', data);
    },
    getList: function getList() {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('api/notices');
    },
    remove: function remove(id) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.delete('api/notices/' + id);
    }
  },
  product: {
    archive: function archive(id) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.put('api/products/' + id, { archived: true });
    },
    unArchive: function unArchive(id) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.put('api/products/' + id, { archived: false });
    },
    getList: function getList() {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('api/products');
    },
    post: function post(data) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post('api/products', data);
    },
    updateFeatured: function updateFeatured(ids) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('api/products/action/update_featured', {
        params: {
          ids: ids
        }
      });
    }
  },
  planDefinition: {
    getList: function getList() {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('api/plan_definitions');
    }
  },
  payment: {
    getList: function getList() {
      var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('api/payments?order.user.email=' + search);
    },
    setAsPaid: function setAsPaid(id) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('api/payments/' + id + '/set_as_paid');
    }
  },
  user: {
    getList: function getList() {
      var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var packet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      var params = {};
      if (search) {
        params['email'] = search;
      }
      if (packet) {
        params['access.name'] = packet;
      }
      if (type) {
        params['type'] = type;
      }
      var encoded = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).map(function (k) {
        return k + '=' + params[k];
      }).join('&');
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('api/users?' + encoded);
    },
    getItem: function getItem(id) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('api/users/' + id);
    },
    changePlanDefinition: function changePlanDefinition(id, planId, from, to, trial) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('api/users/' + id + '/change_plan_definition/' + planId + '?from=' + from + '&to=' + to + '&trial=' + trial);
    },
    resendActivation: function resendActivation(id) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('api/users/' + id + '/resend/activation');
    }
  },
  card: {
    get: function get(day, success, error) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('api/cards/' + day).then(success, error);
    },
    put: function put(day, card) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.put('api/cards/' + day, card);
    },
    usePrevious: function usePrevious(id) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('api/cards/' + id + '/use_previous');
    },
    publish: function publish(id) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('api/cards/' + id + '/publish');
    },
    notify: function notify(id) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('api/cards/' + id + '/notify');
    }
  },
  record: {
    update: function update(id, record) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.put('api/records/' + id, record);
    },
    get: function get(id, success, error) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('api/records/' + id).then(success, error);
    }
  },
  producer: {
    moveUp: function moveUp(id) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.put('api/producers/' + id + '/move_up');
    },
    moveDown: function moveDown(id) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.put('api/producers/' + id + '/move_down');
    },
    post: function post(producer) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post('api/producers', producer);
    },
    update: function update(id, record) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.put('api/producers/' + id, record);
    },
    remove: function remove(id) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.delete('api/producers/' + id);
    },
    get: function get(id) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('api/producers/' + id);
    },
    getList: function getList() {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('api/producers');
    }
  },
  file: {
    remove: function remove(id) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.delete('api/files/' + id);
    },
    post: function post(data) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post('api/files', data);
    },
    getList: function getList() {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('api/files');
    }
  },
  auth: {
    login: function login(username, password) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.post('api/login_check', {
        _username: username,
        _password: password
      });
    }
  },
  homepage: {
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('api/homepages/1');
    }
  },
  regulation: {
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('api/regulations/1');
    },
    put: function put(regulation) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.put('api/regulations/1', regulation);
    }
  },
  producerList: {
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('api/producer_lists/1');
    },
    put: function put(producer) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.put('api/producer_lists/1', producer);
    }
  },
  contact: {
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.get('api/contacts/1');
    },
    put: function put(data) {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.put('api/contacts/1', data);
    }
  }
});

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_notify__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_notify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_notify__);



/* harmony default export */ __webpack_exports__["a"] = ({
  success: function success(message) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.notify({
      message: message
    }, {
      type: 'success'
    });
  },
  error: function error(message) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.notify({
      message: message
    }, {
      type: 'danger'
    });
  }
});

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(439),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(424),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(431),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(432),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(447),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(3);




var TOKEN = 'token';
var REFRESH_TOKEN = 'refresh_token';
var EMAIL = 'email';
var ROLES = 'roles';

/* harmony default export */ __webpack_exports__["a"] = ({
  removeAuthData: function removeAuthData() {
    __WEBPACK_IMPORTED_MODULE_1_store___default.a.remove(TOKEN);
    __WEBPACK_IMPORTED_MODULE_1_store___default.a.remove(REFRESH_TOKEN);
    __WEBPACK_IMPORTED_MODULE_1_store___default.a.remove(EMAIL);
    __WEBPACK_IMPORTED_MODULE_1_store___default.a.remove(ROLES);
  },
  hasToken: function hasToken() {
    return !!__WEBPACK_IMPORTED_MODULE_1_store___default.a.get(TOKEN);
  },
  getToken: function getToken() {
    return __WEBPACK_IMPORTED_MODULE_1_store___default.a.get(TOKEN);
  },
  hasRefreshToken: function hasRefreshToken() {
    return !!__WEBPACK_IMPORTED_MODULE_1_store___default.a.get(REFRESH_TOKEN);
  },
  getRefreshToken: function getRefreshToken() {
    return __WEBPACK_IMPORTED_MODULE_1_store___default.a.get(REFRESH_TOKEN);
  },
  setRefreshToken: function setRefreshToken(token) {
    __WEBPACK_IMPORTED_MODULE_1_store___default.a.set(REFRESH_TOKEN, token);
  },
  setToken: function setToken(token) {
    __WEBPACK_IMPORTED_MODULE_1_store___default.a.set(TOKEN, token);
  },
  setEmail: function setEmail(email) {
    __WEBPACK_IMPORTED_MODULE_1_store___default.a.set(EMAIL, email);
  },
  setRoles: function setRoles(roles) {
    __WEBPACK_IMPORTED_MODULE_1_store___default.a.set(ROLES, roles);
  },
  getEmail: function getEmail() {
    return __WEBPACK_IMPORTED_MODULE_1_store___default.a.get(EMAIL);
  },
  getRoles: function getRoles() {
    return __WEBPACK_IMPORTED_MODULE_1_store___default.a.get(ROLES);
  },
  login: function login(username, password) {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].auth.login(username, password).then(function (_ref) {
        var body = _ref.body;

        if (_this.isNoAdmin(body.roles)) {
          _this.removeAuthData();
          reject('Użytkownik nie posiada uprawnień administratora');
        } else {
          _this.setToken(body.token);
          _this.setRefreshToken(body.refresh_token);
          _this.setEmail(body.email);
          _this.setRoles(body.roles);
          resolve();
        }
      }, function () {
        return reject('Nie udało się zalogować');
      });
    });
  },
  logout: function logout() {
    this.removeAuthData();
  },
  isNoAdmin: function isNoAdmin(roles) {
    return !(roles.includes('ROLE_ADMIN') || roles.includes('ROLE_SUPER_ADMIN'));
  }
});

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(339)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(435),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(440),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var store = {
  state: {
    loading: false,
    menu: true
  }
};
/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(465),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(464),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(443),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(466),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */,
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return origins; });
var origins = [{ label: 'Kraj', value: 'kraj' }, { label: 'Import', value: 'import' }];

/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(427),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(426),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(437),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(461),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(433),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */,
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



var formatter = new Intl.NumberFormat('pl-PL', {
  style: 'currency',
  currency: 'PLN',
  minimumFractionDigits: 2
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('currency', function (value) {
  return formatter.format(value);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('access', function (value) {
  if (value === 'free') {
    return 'Free';
  }
  if (value === 'premium') {
    return 'Premium';
  }
  if (value === 'pro') {
    return 'Premium + SMS';
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('date', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD hh:mm');
  }
  return '';
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('state', function (value) {
  if (value === 'realized') {
    return 'Zrealizowane';
  }
  if (value === 'new') {
    return 'Nowe';
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('type', function (value) {
  if (value === 'buyer') {
    return 'Kupujący';
  }
  if (value === 'seller') {
    return 'Sprzedający';
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(47);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.root = "https://gieldakaliska.pl/";

// xdebug
// Vue.http.interceptors.push((request, next) => {
//   request.params.XDEBUG_SESSION_START = 'PHPSTORM'
//   next()
// })

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (req, next) {
  __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.loading = true;
  if (__WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */].hasToken()) {
    req.headers.set('Authorization', 'Bearer ' + __WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */].getToken());
  }
  if (req.url.includes('api') && !(req.url.includes('api/login_check') || req.url.includes('api/token/refresh'))) {
    req.headers.set('Content-Type', 'application/json');
    req.headers.set('Accept', 'application/json');
  }
  next(function (res) {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.loading = false;
    if (res.status === 404) {
      window.alert('Wyst\u0105pi\u0142 nieoczekiwany b\u0142\u0105d, nie odnaleziono obiektu pod adresem ' + res.url + ' - skontaktuj si\u0119 z administratorem');
    }
    if (res.status === 500) {
      window.alert('Wystąpił nieoczekiwany błąd aplikacji, skontaktuj się z administratorem');
    }
    if (res.status === 401 && !(req.url.includes('api/login_check') || req.url.includes('api/token/refresh'))) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post('api/token/refresh', {
        refresh_token: __WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */].getRefreshToken()
      }).then(function (_ref) {
        var body = _ref.body;

        __WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */].setToken(body.token);
        __WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */].setRefreshToken(body.refresh_token);
        return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http[req.method.toLowerCase()](req.url, req.body);
      }, function () {
        __WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */].removeAuthData();
        window.location.reload();
      });
    }
  });
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_vue__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Homepage_vue__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Homepage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Homepage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Producers_vue__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Producers_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Producers_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ProducerAddEdit_vue__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ProducerAddEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ProducerAddEdit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ProductAddEdit_vue__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ProductAddEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ProductAddEdit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Records_vue__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Records_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Records_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Products_vue__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Products_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Products_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_RecordEdit_vue__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_RecordEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_RecordEdit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Notices_vue__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Notices_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Notices_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_NoticeAddEdit_vue__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_NoticeAddEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_NoticeAddEdit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Regulations_vue__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Regulations_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Regulations_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_PriceList_vue__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_PriceList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_PriceList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Contact_vue__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Contact_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Contact_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Users_vue__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Users_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Users_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ChangePackage_vue__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ChangePackage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_ChangePackage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Payments_vue__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Payments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Payments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Login_vue__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__auth__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_moment__);






















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

function requireAuth(to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_19__auth__["a" /* default */].hasToken()) {
    next({
      name: 'Login'
    });
  } else {
    next();
  }
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [{
    name: 'Dashboard',
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Dashboard_vue___default.a,
    redirect: function redirect() {
      return {
        name: 'Records',
        params: {
          id: __WEBPACK_IMPORTED_MODULE_20_moment___default()().format('YYYY-MM-DD')
        }
      };
    }
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_18__components_Login_vue___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      if (__WEBPACK_IMPORTED_MODULE_19__auth__["a" /* default */].hasToken()) {
        next({
          path: '/'
        });
      } else {
        next();
      }
    }
  }, {
    path: '/homepage',
    name: 'Homepage',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Homepage_vue___default.a,
    beforeEnter: requireAuth
  }, {
    path: '/producers',
    name: 'Producers',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Producers_vue___default.a,
    beforeEnter: requireAuth
  }, {
    path: '/producers/add',
    name: 'ProducerAdd',
    component: __WEBPACK_IMPORTED_MODULE_5__components_ProducerAddEdit_vue___default.a,
    beforeEnter: requireAuth,
    props: true
  }, {
    path: '/producers/:id/edit',
    name: 'ProducerEdit',
    component: __WEBPACK_IMPORTED_MODULE_5__components_ProducerAddEdit_vue___default.a,
    props: true,
    beforeEnter: requireAuth
  }, {
    path: '/records/list/:id/:search?',
    name: 'Records',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Records_vue___default.a,
    props: true,
    beforeEnter: requireAuth
  }, {
    path: '/products/list',
    name: 'Products',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Products_vue___default.a,
    props: true,
    beforeEnter: requireAuth
  }, {
    path: '/products/create',
    name: 'ProductAdd',
    component: __WEBPACK_IMPORTED_MODULE_6__components_ProductAddEdit_vue___default.a,
    beforeEnter: requireAuth
  }, {
    path: '/records/edit/:id',
    name: 'RecordEdit',
    component: __WEBPACK_IMPORTED_MODULE_9__components_RecordEdit_vue___default.a,
    props: true,
    beforeEnter: requireAuth
  }, {
    path: '/notices',
    name: 'Notices',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Notices_vue___default.a,
    beforeEnter: requireAuth
  }, {
    path: '/notices/add',
    name: 'NoticeAdd',
    component: __WEBPACK_IMPORTED_MODULE_11__components_NoticeAddEdit_vue___default.a,
    beforeEnter: requireAuth,
    props: true
  }, {
    path: '/notices/:id/edit',
    name: 'NoticeEdit',
    component: __WEBPACK_IMPORTED_MODULE_11__components_NoticeAddEdit_vue___default.a,
    props: true,
    beforeEnter: requireAuth
  }, {
    path: '/regulations',
    name: 'Regulations',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Regulations_vue___default.a,
    beforeEnter: requireAuth
  }, {
    path: '/price-list',
    name: 'PriceList',
    component: __WEBPACK_IMPORTED_MODULE_13__components_PriceList_vue___default.a,
    beforeEnter: requireAuth
  }, {
    path: '/contact',
    name: 'Contact',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Contact_vue___default.a,
    beforeEnter: requireAuth
  }, {
    path: '/users',
    name: 'Users',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Users_vue___default.a,
    beforeEnter: requireAuth
  }, {
    path: '/users/:id/change-package',
    name: 'ChangePackage',
    component: __WEBPACK_IMPORTED_MODULE_16__components_ChangePackage_vue___default.a,
    beforeEnter: requireAuth,
    props: true
  }, {
    path: '/payments',
    name: 'Payments',
    component: __WEBPACK_IMPORTED_MODULE_17__components_Payments_vue___default.a,
    beforeEnter: requireAuth
  }]
}));

/***/ }),
/* 249 */,
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(340)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(448),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */,
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/* harmony default export */ __webpack_exports__["a"] = ({
  create: function create(config) {
    this.config = config;
    this.fields = this._flatten(config);
    return this;
  },
  setData: function setData(body) {
    this.fields = body;
  },
  _flatten: function _flatten(config) {
    var fields = {};
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(config).forEach(function (key) {
      config[key].forEach(function (f) {
        fields[f.name] = '';
      });
    });
    return fields;
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_focus__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_focus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filters__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__http__ = __webpack_require__(247);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.keyCodes.plus = 107;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.keyCodes.minus = 109;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('focus', __WEBPACK_IMPORTED_MODULE_2_vue_focus__["focus"]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Sidebar_vue__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Sidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TopHeader_vue__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TopHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_TopHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state;
  },

  components: {
    Sidebar: __WEBPACK_IMPORTED_MODULE_0__components_Sidebar_vue___default.a,
    TopHeader: __WEBPACK_IMPORTED_MODULE_1__components_TopHeader_vue___default.a
  },
  computed: {
    authenticated: function authenticated() {
      return __WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */].hasToken();
    },
    containerClasses: function containerClasses() {
      if (!this.authenticated) {
        return { 'col-sm-12': true };
      }
      if (this.menu) {
        return { 'col-sm-10': true };
      }
      return { 'col-sm-12': true };
    },
    sidebarClasses: function sidebarClasses() {
      if (this.menu) {
        return { 'col-sm-2': true };
      }
      return { 'hidden': true };
    }
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    state: { type: Boolean, required: true }
  },
  computed: {
    classes: function classes() {
      return {
        'label-danger': !this.state,
        'label-success': this.state
      };
    },
    stateForHuman: function stateForHuman() {
      switch (this.state) {
        case true:
          return 'TAK';
        default:
          return 'NIE';
      }
    }
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Flash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__QuestionButton_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__QuestionButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__QuestionButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DatePicker_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DatePicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DatePicker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CheckboxInput_vue__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CheckboxInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CheckboxInput_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    id: { type: [Number, String], required: true }
  },
  components: {
    QuestionButton: __WEBPACK_IMPORTED_MODULE_2__QuestionButton_vue___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_3__DatePicker_vue___default.a,
    CheckboxInput: __WEBPACK_IMPORTED_MODULE_4__CheckboxInput_vue___default.a
  },
  data: function data() {
    return {
      planDefinitions: [],
      user: {
        access: {
          planDefinition: {}
        }
      },
      newPlanDefinition: null,
      from: '',
      to: '',
      trial: false
    };
  },

  methods: {
    fetchData: function fetchData() {
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].planDefinition.getList().then(this.onGetPlanDefinitionListSuccess);
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].user.getItem(this.id).then(this.onGetUserSuccess);
    },
    onGetPlanDefinitionListSuccess: function onGetPlanDefinitionListSuccess(_ref) {
      var body = _ref.body;

      this.planDefinitions = body;
    },
    onGetUserSuccess: function onGetUserSuccess(_ref2) {
      var body = _ref2.body;

      this.user = body;
    },
    submit: function submit() {
      if (this.newPlanDefinition === null) {
        __WEBPACK_IMPORTED_MODULE_1__Flash__["a" /* default */].error('Nie wybrano nowego planu');
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].user.changePlanDefinition(this.id, this.newPlanDefinition, this.from, this.to, this.trial).then(this.onPlanChangeSuccess, this.onPlanChangeError);
    },
    onPlanChangeSuccess: function onPlanChangeSuccess(_ref3) {
      var body = _ref3.body;

      this.user = body;
      __WEBPACK_IMPORTED_MODULE_1__Flash__["a" /* default */].success('Zmieniono plan użytkownikowi');
    },
    onPlanChangeError: function onPlanChangeError() {
      __WEBPACK_IMPORTED_MODULE_1__Flash__["a" /* default */].error('Wystąpił błąd podczas zmiany planu, skontaktuj się z administratorem');
    }
  },
  watch: {
    '$route': 'fetchData'
  },
  created: function created() {
    this.fetchData();
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    label: { type: String },
    checked: { type: Boolean, required: true }
  },
  methods: {
    change: function change(e) {
      this.$emit('change', e.target.checked);
    }
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SubmitButton_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SubmitButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SubmitButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormGroup_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FormGroup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextareaInput_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextareaInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TextareaInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TextInput_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TextInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TextInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Flash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      errors: [],
      submitting: false,
      contact: {
        companyData: '',
        phonesData: '',
        contactEmail: ''
      }
    };
  },

  components: {
    SubmitButton: __WEBPACK_IMPORTED_MODULE_0__SubmitButton_vue___default.a,
    FormGroup: __WEBPACK_IMPORTED_MODULE_1__FormGroup_vue___default.a,
    TextareaInput: __WEBPACK_IMPORTED_MODULE_2__TextareaInput_vue___default.a,
    TextInput: __WEBPACK_IMPORTED_MODULE_3__TextInput_vue___default.a
  },
  methods: {
    submit: function submit() {
      var _this = this;

      this.errors = [];
      this.submitting = true;
      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].contact.put(this.contact).then(this.onSubmitSuccess, this.updateError).then(function () {
        _this.submitting = false;
      });
    },
    onSubmitSuccess: function onSubmitSuccess() {
      __WEBPACK_IMPORTED_MODULE_4__Flash__["a" /* default */].success('Zaktualizowano dane kontaktowe poprawnie');
    },
    updateError: function updateError() {
      __WEBPACK_IMPORTED_MODULE_4__Flash__["a" /* default */].error('Niestety nie udało się zaktualizować danych kontaktowych, skontaktuj się z administratorem');
    },
    fetchData: function fetchData() {
      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].contact.get().then(this.fetchSuccess);
    },
    fetchSuccess: function fetchSuccess(_ref) {
      var body = _ref.body;

      this.contact = body;
    }
  },
  created: function created() {
    this.fetchData();
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_accounting__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_accounting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_accounting__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: { type: String, required: true }
  },
  data: function data() {
    return {
      error: false
    };
  },

  computed: {
    formattedValue: function formattedValue() {
      return __WEBPACK_IMPORTED_MODULE_0_accounting___default.a.formatMoney(this.value.replace(',', '.'), '', 2, ' ', ',');
    }
  },
  methods: {
    update: function update(event) {
      var newValue = __WEBPACK_IMPORTED_MODULE_0_accounting___default.a.formatMoney(event.target.value.replace(',', '.'), '', 2, ' ', '.');
      if (newValue !== this.value) {
        this.$emit('input', newValue);
      } else {
        event.target.value = this.formattedValue;
      }
    }
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_datepicker__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_datepicker_dist_locales_bootstrap_datepicker_pl_min__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_datepicker_dist_locales_bootstrap_datepicker_pl_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_datepicker_dist_locales_bootstrap_datepicker_pl_min__);
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: { required: true }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$refs.datepicker).datepicker({
      format: 'yyyy-mm-dd',
      language: 'pl',
      autoclose: true
    }).on('changeDate', function () {
      _this.$emit('input', _this.$refs.datepicker.value);
    });
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$refs.datepicker).datepicker('destroy');
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: { required: true }
  },
  methods: {
    change: function change(e) {
      var files = e.target.files || e.dataTransfer.files;
      console.log(files);
    }
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormGroup_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FormGroup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TextInput_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TextInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TextInput_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FormData',
  props: {
    url: { type: String, required: true },
    method: { type: String, default: 'POST' },
    form: { type: Object, required: true }
  },
  data: function data() {
    return {
      submitting: false,
      errors: {}
    };
  },

  components: {
    FormGroup: __WEBPACK_IMPORTED_MODULE_2__FormGroup_vue___default.a,
    TextInput: __WEBPACK_IMPORTED_MODULE_3__TextInput_vue___default.a
  },
  methods: {
    submit: function submit() {
      var _this = this;

      this.submitting = true;
      var fields = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.form.fields);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(fields).forEach(function (k) {
        if (k.includes('@')) {
          delete fields[k];
        }
      });
      this.$http[this.normalizedMethod](this.url, fields).then(this.handleSuccess, this.handleError).then(function () {
        _this.submitting = false;
      });
    },
    handleSuccess: function handleSuccess() {
      this.errors = {};
      this.$emit('success');
    },
    handleError: function handleError(_ref) {
      var status = _ref.status,
          body = _ref.body;

      if (status === 400) {
        this.errors = this.normalizeErrors(body.violations);
      }
    },
    normalizeErrors: function normalizeErrors(errors) {
      var newErrors = {};
      errors.forEach(function (e) {
        newErrors[e.propertyPath] = e.message;
      });
      return newErrors;
    }
  },
  computed: {
    normalizedMethod: function normalizedMethod() {
      return this.method.toLowerCase();
    }
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    label: { type: String },
    stacked: { type: Boolean, default: false },
    labelCol: { type: Number, default: 2 },
    controlCol: { type: Number, default: 10 },
    offsetCol: { type: Number },
    error: {}
  },
  computed: {
    hasAddon: function hasAddon() {
      return !!this.$slots.addon;
    },
    horizontal: function horizontal() {
      return !this.stacked;
    },
    labelClass: function labelClass() {
      return 'col-sm-' + this.labelCol;
    },
    controlClass: function controlClass() {
      return 'col-sm-' + this.controlCol;
    },
    hasError: function hasError() {
      return !!this.error;
    },
    controlClasses: function controlClasses() {
      var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.controlClass, this.horizontal);
      if (this.offsetCol) {
        classes['col-sm-offset-' + this.offsetCol] = true;
      }
      return classes;
    },
    inputGroupClasses: function inputGroupClasses() {
      return {
        'input-group': this.hasAddon
      };
    }
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormData_vue__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__FormData_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Flash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Homepage',
  data: function data() {
    return {
      form: __WEBPACK_IMPORTED_MODULE_1__Form__["a" /* default */].create({
        'Slogan': [{ name: 'sloganFirst', label: 'Slogan cz. 1' }, { name: 'sloganSecond', label: 'Slogan cz. 2 ' }],
        'Statystyki': [{ name: 'statsFirstNumber', label: 'Okno 1 liczby' }, { name: 'statsFirstContent', label: 'Okno 1 treść' }, { name: 'statsSecondNumber', label: 'Okno 2 liczby' }, { name: 'statsSecondContent', label: 'Okno 2 treść' }, { name: 'statsThirdNumber', label: 'Okno 3 liczby' }, { name: 'statsThirdContent', label: 'Okno 3 treść' }, { name: 'statsFourthNumber', label: 'Okno 4 liczby' }, { name: 'statsFourthContent', label: 'Okno 4 treść' }],
        'Zaproszenie': [{ name: 'inviteHeader', label: 'Nagłówek' }, { name: 'sellerHeader', label: 'Sprzedający - nagłówek' }, { name: 'sellerContent', label: 'Sprzedający - treść' }, { name: 'buyerHeader', label: 'Kupujący - nagłówek' }, { name: 'buyerContent', label: 'Kupujący - treść' }],
        'Inne': [{ name: 'phoneTop', label: 'Telefon' }]
      })
    };
  },

  components: {
    FormData: __WEBPACK_IMPORTED_MODULE_0__FormData_vue___default.a
  },
  methods: {
    onSubmitSuccess: function onSubmitSuccess() {
      __WEBPACK_IMPORTED_MODULE_2__Flash__["a" /* default */].success('Zaktualizowano stronę główną poprawnie');
    },
    fetchData: function fetchData() {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].homepage.get().then(this.fetchSuccess);
    },
    fetchSuccess: function fetchSuccess(_ref) {
      var body = _ref.body;

      this.form.setData(body);
    }
  },
  created: function created() {
    this.fetchData();
  }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    media: { type: Object, required: true }
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CenterHeader_vue__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CenterHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CenterHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormGroup_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FormGroup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextInput_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TextInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth__ = __webpack_require__(31);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      logging: false,
      email: '',
      password: '',
      error: ''
    };
  },

  components: {
    CenterHeader: __WEBPACK_IMPORTED_MODULE_0__CenterHeader_vue___default.a,
    FormGroup: __WEBPACK_IMPORTED_MODULE_1__FormGroup_vue___default.a,
    TextInput: __WEBPACK_IMPORTED_MODULE_2__TextInput_vue___default.a
  },
  methods: {
    submit: function submit() {
      var _this = this;

      this.error = '';
      this.logging = true;
      __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */].login(this.email, this.password).then(this.loginSuccess, this.loginError).then(function () {
        _this.logging = false;
      });
    },
    loginSuccess: function loginSuccess() {
      window.location.reload();
    },
    loginError: function loginError(message) {
      this.error = message;
    }
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MediaItem_vue__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MediaItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MediaItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MediaManager_vue__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MediaManager_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MediaManager_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: { required: true },
    multiple: { type: Boolean }
  },
  data: function data() {
    return {
      showMediaManager: false
    };
  },

  components: {
    MediaItem: __WEBPACK_IMPORTED_MODULE_0__MediaItem_vue___default.a,
    MediaManager: __WEBPACK_IMPORTED_MODULE_1__MediaManager_vue___default.a
  },
  methods: {
    onDelete: function onDelete(media) {
      if (this.multiple) {
        var currentValues = this.localValue;
        currentValues.splice(currentValues.indexOf(media), 1);
        this.$emit('input', currentValues);
      } else {
        this.$emit('input', null);
      }
    },
    onSelect: function onSelect(media) {
      if (!this.multiple) {
        this.showMediaManager = false;
        this.$emit('input', media);
      } else {
        var medias = this.localValue;
        medias.push(media);
        this.$emit('input', medias);
      }
    },
    onUnSelect: function onUnSelect(media) {
      if (!this.multiple) {
        this.showMediaManager = false;
        this.$emit('input', null);
      } else {
        var currentValues = this.localValue;
        currentValues.splice(currentValues.indexOf(media), 1);
        this.$emit('input', currentValues);
      }
    }
  },
  computed: {
    localValue: function localValue() {
      if (!(this.value instanceof Array)) {
        if (this.value) {
          return [this.value];
        }
        return [];
      }
      return this.value;
    },
    showBrowse: function showBrowse() {
      return !this.showMediaManager && this.valueIsEmpty;
    },
    valueIsEmpty: function valueIsEmpty() {
      return this.localValue.length === 0;
    }
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    media: { required: true }
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__QuestionButton_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__QuestionButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__QuestionButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LargeMedia_vue__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LargeMedia_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LargeMedia_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    selected: { type: Array, required: true }
  },
  data: function data() {
    return {
      fetching: false,
      medias: [],
      errors: {},
      large: null
    };
  },

  components: {
    QuestionButton: __WEBPACK_IMPORTED_MODULE_1__QuestionButton_vue___default.a,
    LargeMedia: __WEBPACK_IMPORTED_MODULE_2__LargeMedia_vue___default.a
  },
  methods: {
    isSelected: function isSelected(media) {
      return this.selected.find(function (m) {
        return m.id === media.id;
      });
    },
    showLarge: function showLarge(media) {
      this.large = media;
    },
    closeLarge: function closeLarge() {
      this.large = null;
    },
    remove: function remove(media) {
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].file.remove(media.id).then(this.onRemoveSuccess(media), this.onRemoveError);
    },
    onRemoveSuccess: function onRemoveSuccess(media) {
      var _this = this;

      return function () {
        _this.medias.splice(_this.medias.indexOf(media), 1);
      };
    },
    onRemoveError: function onRemoveError(_ref) {
      var body = _ref.body;

      window.alert(body.detail);
    },
    select: function select(media) {
      this.$emit('select', media);
    },
    unSelect: function unSelect(media) {
      this.$emit('unselect', media);
    },
    onFileChanged: function onFileChanged(e) {
      this.upload(e.target.files);
    },
    upload: function upload(files) {
      var formData = new FormData();
      for (var i = 0; i < files.length; i++) {
        var file = files.item(i);
        formData.append('files[]', file);
      }
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].file.post(formData).then(this.onUploadSuccess, this.onUploadError);
    },
    onUploadSuccess: function onUploadSuccess(_ref2) {
      var body = _ref2.body;

      this.medias.push(body);
    },
    onUploadError: function onUploadError(_ref3) {
      var _this2 = this;

      var body = _ref3.body;

      body.violations.forEach(function (violation) {
        _this2.$set(_this2.errors, violation.propertyPath, violation.message);
      });
    },
    fetchData: function fetchData() {
      var _this3 = this;

      this.fetching = true;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].file.getList().then(this.onFetchSuccess, this.onFetchError).then(function () {
        _this3.fetching = false;
      });
    },
    onFetchSuccess: function onFetchSuccess(_ref4) {
      var body = _ref4.body;

      this.medias = body;
    },
    onFetchError: function onFetchError() {
      window.alert('Nie udało się pobrać plików - skontaktuj się z administratorem');
    }
  },
  computed: {
    showEmptyMessage: function showEmptyMessage() {
      return !this.fetching && this.medias.length === 0;
    },
    hasMedias: function hasMedias() {
      return this.medias.length > 0;
    }
  },
  created: function created() {
    this.fetchData();
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormGroup_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FormGroup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextInput_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TextInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FileInput_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FileInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FileInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MediaInput_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MediaInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MediaInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TextareaInput_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TextareaInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TextareaInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SubmitButton_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SubmitButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SubmitButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SelectInput_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SelectInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__SelectInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TableInput_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TableInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__TableInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DatePicker_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DatePicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__DatePicker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Flash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_select__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    id: { type: [String, Number] }
  },
  components: {
    FormGroup: __WEBPACK_IMPORTED_MODULE_1__FormGroup_vue___default.a,
    TextInput: __WEBPACK_IMPORTED_MODULE_2__TextInput_vue___default.a,
    FileInput: __WEBPACK_IMPORTED_MODULE_3__FileInput_vue___default.a,
    MediaInput: __WEBPACK_IMPORTED_MODULE_4__MediaInput_vue___default.a,
    TextareaInput: __WEBPACK_IMPORTED_MODULE_5__TextareaInput_vue___default.a,
    SubmitButton: __WEBPACK_IMPORTED_MODULE_6__SubmitButton_vue___default.a,
    SelectInput: __WEBPACK_IMPORTED_MODULE_7__SelectInput_vue___default.a,
    TableInput: __WEBPACK_IMPORTED_MODULE_8__TableInput_vue___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_9__DatePicker_vue___default.a,
    vSelect: __WEBPACK_IMPORTED_MODULE_12_vue_select___default.a,
    Api: __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */]
  },
  data: function data() {
    return {
      submitting: false,
      notice: {
        header: '',
        slug: '',
        content: '',
        date: '',
        photos: [],
        files: []
      },
      errors: []
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.errors = [];
      this.submitting = true;
      if (this.id) {
        var notice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.notice);
        __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].notice.update(this.id, notice).then(this.updateSuccess, this.updateError).then(function () {
          _this.submitting = false;
        });
      } else {
        var _notice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.notice);
        if (_notice.photos) {
          _notice.photos = this.notice.photos.map(function (p) {
            return '/api/files/' + p.id;
          });
        }
        if (_notice.files) {
          _notice.files = this.notice.files.map(function (p) {
            return '/api/files/' + p.id;
          });
        }
        __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].notice.post(_notice).then(this.updateSuccess, this.updateError).then(function () {
          _this.submitting = false;
        });
      }
    },
    updateSuccess: function updateSuccess(_ref) {
      var body = _ref.body;

      this.setData(body);
      __WEBPACK_IMPORTED_MODULE_11__Flash__["a" /* default */].success('Zapisano zmiany poprawnie');
      this.$router.push({
        name: 'NoticeEdit',
        params: {
          id: this.notice.id
        }
      });
    },
    updateError: function updateError(_ref2) {
      var _this2 = this;

      var body = _ref2.body;

      var violations = body.violations;
      violations.forEach(function (violation) {
        _this2.errors[violation.propertyPath] = violation.message;
      });
    },
    fetchData: function fetchData() {
      if (this.id) {
        __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].notice.get(this.id).then(this.fetchSuccess);
      }
    },
    fetchSuccess: function fetchSuccess(_ref3) {
      var body = _ref3.body;

      this.setData(body);
    },
    setData: function setData(body) {
      body.date = __WEBPACK_IMPORTED_MODULE_13_moment___default()(body.date).format('YYYY-MM-DD');
      this.notice = body;
    }
  },
  created: function created() {
    this.fetchData();
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__QuestionButton_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__QuestionButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__QuestionButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Flash__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      notices: []
    };
  },

  components: {
    QuestionButton: __WEBPACK_IMPORTED_MODULE_1__QuestionButton_vue___default.a
  },
  methods: {
    remove: function remove(notice) {
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].notice.remove(notice.id).then(this.onRemoveSuccess(notice), this.onRemoveError);
    },
    onRemoveSuccess: function onRemoveSuccess(notice) {
      var _this = this;

      return function () {
        _this.notices.splice(_this.notices.indexOf(notice), 1);
        __WEBPACK_IMPORTED_MODULE_2__Flash__["a" /* default */].success('Ogłoszenie zostało poprawnie usuniętę');
      };
    },
    onRemoveError: function onRemoveError() {
      __WEBPACK_IMPORTED_MODULE_2__Flash__["a" /* default */].error('Wystąpił nieoczekiwany błąd podczas usuwania ogłoszenia, skontaktuj się z administratorem');
    },
    getRouteToEdit: function getRouteToEdit(notice) {
      return {
        name: 'NoticeEdit',
        params: {
          id: notice.id
        }
      };
    },
    fetchData: function fetchData() {
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].notice.getList().then(this.fetchSuccess);
    },
    fetchSuccess: function fetchSuccess(_ref) {
      var body = _ref.body;

      this.notices = body;
    }
  },
  computed: {
    getRouteToAdd: function getRouteToAdd() {
      return {
        name: 'NoticeAdd'
      };
    }
  },
  created: function created() {
    this.fetchData();
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    state: { type: String, required: true }
  },
  computed: {
    classes: function classes() {
      return {
        'label-danger': this.state !== 'realized',
        'label-success': this.state === 'realized'
      };
    },
    stateForHuman: function stateForHuman() {
      switch (this.state) {
        case 'realized':
          return 'TAK';
        default:
          return 'NIE';
      }
    }
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Flash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__QuestionButton_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__QuestionButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__QuestionButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PaymentState_vue__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PaymentState_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PaymentState_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_debounce__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_tiny_debounce__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      search: '',
      payments: []
    };
  },

  components: {
    QuestionButton: __WEBPACK_IMPORTED_MODULE_2__QuestionButton_vue___default.a,
    PaymentState: __WEBPACK_IMPORTED_MODULE_3__PaymentState_vue___default.a
  },
  methods: {
    fetchData: function fetchData(search) {
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].payment.getList(search).then(this.onGetListSuccess);
    },
    onGetListSuccess: function onGetListSuccess(_ref) {
      var body = _ref.body;

      this.payments = body;
    },
    setAsPaid: function setAsPaid(payment) {
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].payment.setAsPaid(payment.id).then(this.onSetAsPaidSuccess, this.onSetAsPaidError);
    },
    onSetAsPaidSuccess: function onSetAsPaidSuccess(_ref2) {
      var body = _ref2.body;

      var payment = this.payments.find(function (p) {
        return p.id === body.id;
      });
      var idx = this.payments.indexOf(payment);
      this.$set(this.payments, idx, body);
      __WEBPACK_IMPORTED_MODULE_1__Flash__["a" /* default */].success('Oznaczono opłacenie i zrealizowano zamówienie');
    },
    onSetAsPaidError: function onSetAsPaidError() {
      __WEBPACK_IMPORTED_MODULE_1__Flash__["a" /* default */].error('Wystąpił błąd podczas oznaczenia opłacenia');
    },

    debounceSearch: __WEBPACK_IMPORTED_MODULE_4_tiny_debounce___default()(function (value) {
      this.fetchData(value);
    }, 500)
  },
  watch: {
    '$route': 'fetchData',
    'search': 'debounceSearch'
  },
  created: function created() {
    this.fetchData();
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormGroup_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__FormGroup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TextInput_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TextInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TextInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SubmitButton_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SubmitButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SubmitButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DatePicker_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DatePicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DatePicker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Flash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TrashIcon_vue__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TrashIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__TrashIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__QuestionButton_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__QuestionButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__QuestionButton_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    FormGroup: __WEBPACK_IMPORTED_MODULE_0__FormGroup_vue___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_3__DatePicker_vue___default.a,
    TextInput: __WEBPACK_IMPORTED_MODULE_1__TextInput_vue___default.a,
    SubmitButton: __WEBPACK_IMPORTED_MODULE_2__SubmitButton_vue___default.a,
    TrashIcon: __WEBPACK_IMPORTED_MODULE_7__TrashIcon_vue___default.a,
    QuestionButton: __WEBPACK_IMPORTED_MODULE_8__QuestionButton_vue___default.a,
    Api: __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */]
  },
  data: function data() {
    return {
      submitting: false,
      priceList: {
        forSellers: [],
        forBuyers: []
      },
      errors: []
    };
  },

  methods: {
    addPosition: function addPosition(list) {
      list.push({
        type: '',
        price: ''
      });
    },
    removePosition: function removePosition(list, item) {
      list.splice(list.indexOf(item), 1);
    },
    submit: function submit() {
      var _this = this;

      this.errors = [];
      this.submitting = true;
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].priceList.update(1, this.priceList).then(this.updateSuccess, this.updateError).then(function () {
        _this.submitting = false;
      });
    },
    updateSuccess: function updateSuccess(_ref) {
      var body = _ref.body;

      body.date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(body.date).format('YYYY-MM-DD');
      this.priceList = body;
      __WEBPACK_IMPORTED_MODULE_5__Flash__["a" /* default */].success('Zapisano zmiany poprawnie');
      this.$router.push({
        name: 'PriceList'
      });
    },
    updateError: function updateError(_ref2) {
      var _this2 = this;

      var body = _ref2.body;

      var violations = body.violations;
      violations.forEach(function (violation) {
        _this2.errors[violation.propertyPath] = violation.message;
      });
    },
    fetchData: function fetchData() {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].priceList.get(1).then(this.fetchSuccess);
    },
    onFetchProductsError: function onFetchProductsError() {
      window.alert('Wystąpił nieoczekiwany błąd podczas pobierania produktów - skontaktuj się z administratorem');
    },
    fetchSuccess: function fetchSuccess(_ref3) {
      var body = _ref3.body;

      body.date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(body.date).format('YYYY-MM-DD');
      this.priceList = body;
    }
  },
  created: function created() {
    this.fetchData();
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormGroup_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FormGroup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextInput_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TextInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FileInput_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FileInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FileInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MediaInput_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MediaInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MediaInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TextareaInput_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TextareaInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TextareaInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SubmitButton_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SubmitButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SubmitButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SelectInput_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SelectInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__SelectInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TableInput_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TableInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__TableInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Flash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_select__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_select__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    id: { type: [String, Number] }
  },
  components: {
    FormGroup: __WEBPACK_IMPORTED_MODULE_1__FormGroup_vue___default.a,
    TextInput: __WEBPACK_IMPORTED_MODULE_2__TextInput_vue___default.a,
    FileInput: __WEBPACK_IMPORTED_MODULE_3__FileInput_vue___default.a,
    MediaInput: __WEBPACK_IMPORTED_MODULE_4__MediaInput_vue___default.a,
    TextareaInput: __WEBPACK_IMPORTED_MODULE_5__TextareaInput_vue___default.a,
    SubmitButton: __WEBPACK_IMPORTED_MODULE_6__SubmitButton_vue___default.a,
    SelectInput: __WEBPACK_IMPORTED_MODULE_7__SelectInput_vue___default.a,
    TableInput: __WEBPACK_IMPORTED_MODULE_8__TableInput_vue___default.a,
    vSelect: __WEBPACK_IMPORTED_MODULE_11_vue_select___default.a,
    Api: __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */]
  },
  data: function data() {
    return {
      submitting: false,
      producer: {
        name: '',
        description: '',
        logo: null,
        products: [],
        openingHours: ''
      },
      productsOptions: [],
      errors: []
    };
  },

  methods: {
    buildLabel: function buildLabel(p) {
      return p.name + ' - ' + (p.variety ? p.variety + ', ' : '') + ' ' + p.origin + ', ' + p.unit;
    },
    submit: function submit() {
      var _this = this;

      this.errors = [];
      this.submitting = true;
      if (this.id) {
        var producer = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.producer);
        if (producer.products.length > 0) {
          producer.products = this.producer.products.map(function (p) {
            return '/api/products/' + p.value;
          });
        }
        __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].producer.update(this.id, producer).then(this.updateSuccess, this.updateError).then(function () {
          _this.submitting = false;
        });
      } else {
        var _producer = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.producer);
        if (_producer.logo) {
          _producer.logo = '/api/files/' + this.producer.logo.id;
        }
        if (_producer.products.length > 0) {
          _producer.products = this.producer.products.map(function (p) {
            return '/api/products/' + p.value;
          });
        }
        __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].producer.post(_producer).then(this.updateSuccess, this.updateError).then(function () {
          _this.submitting = false;
        });
      }
    },
    updateSuccess: function updateSuccess(_ref) {
      var body = _ref.body;

      this.producer = this.transform(body);
      __WEBPACK_IMPORTED_MODULE_10__Flash__["a" /* default */].success('Zapisano zmiany poprawnie');
      this.$router.push({
        name: 'ProducerEdit',
        params: {
          id: this.producer.id
        }
      });
    },
    updateError: function updateError(_ref2) {
      var _this2 = this;

      var body = _ref2.body;

      var violations = body.violations;
      violations.forEach(function (violation) {
        _this2.errors[violation.propertyPath] = violation.message;
      });
    },
    fetchData: function fetchData() {
      __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].product.getList().then(this.onFetchProductsSuccess, this.onFetchProductsError);
      if (this.id) {
        __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].producer.get(this.id).then(this.fetchSuccess);
      }
    },
    onFetchProductsSuccess: function onFetchProductsSuccess(_ref3) {
      var _this3 = this;

      var body = _ref3.body;

      this.productsOptions = body.map(function (p) {
        return {
          label: _this3.buildLabel(p),
          value: p.id
        };
      });
    },
    onFetchProductsError: function onFetchProductsError() {
      window.alert('Wystąpił nieoczekiwany błąd podczas pobierania produktów - skontaktuj się z administratorem');
    },
    fetchSuccess: function fetchSuccess(_ref4) {
      var body = _ref4.body;

      this.producer = this.transform(body);
    },
    transform: function transform(body) {
      var _this4 = this;

      body.products = body.products.map(function (p) {
        return {
          label: _this4.buildLabel(p),
          value: p.id
        };
      });
      return body;
    }
  },
  created: function created() {
    this.fetchData();
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormGroup_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__FormGroup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubmitButton_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubmitButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SubmitButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextareaInput_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextareaInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TextareaInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__QuestionButton_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__QuestionButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__QuestionButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Flash__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      producers: [],
      producerList: {
        content: ''
      },
      submitting: false,
      errors: []
    };
  },

  components: {
    QuestionButton: __WEBPACK_IMPORTED_MODULE_4__QuestionButton_vue___default.a,
    SubmitButton: __WEBPACK_IMPORTED_MODULE_1__SubmitButton_vue___default.a,
    TextareaInput: __WEBPACK_IMPORTED_MODULE_2__TextareaInput_vue___default.a,
    FormGroup: __WEBPACK_IMPORTED_MODULE_0__FormGroup_vue___default.a
  },
  methods: {
    submit: function submit() {
      var _this = this;

      this.errors = [];
      this.submitting = true;
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].producerList.put(this.producerList).then(this.onSubmitSuccess, this.updateError).then(function () {
        _this.submitting = false;
      });
    },
    onSubmitSuccess: function onSubmitSuccess() {
      __WEBPACK_IMPORTED_MODULE_5__Flash__["a" /* default */].success('Zaktualizowano treść o kontrahentach');
    },
    updateError: function updateError() {
      __WEBPACK_IMPORTED_MODULE_5__Flash__["a" /* default */].error('Niestety nie udało się zaktualizować treści o kontrahentach, skontaktuj się z administratorem');
    },
    moveUp: function moveUp(producer) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].producer.moveUp(producer.id).then(this.fetchData);
    },
    moveDown: function moveDown(producer) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].producer.moveDown(producer.id).then(this.fetchData);
    },
    remove: function remove(producer) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].producer.remove(producer.id).then(this.onRemoveSuccess(producer), this.onRemoveError);
    },
    onRemoveSuccess: function onRemoveSuccess(producer) {
      var _this2 = this;

      return function () {
        _this2.producers.splice(_this2.producers.indexOf(producer), 1);
        __WEBPACK_IMPORTED_MODULE_5__Flash__["a" /* default */].success('Producent został poprawnie usunięty');
      };
    },
    onRemoveError: function onRemoveError() {
      __WEBPACK_IMPORTED_MODULE_5__Flash__["a" /* default */].error('Wystąpił nieoczekiwany błąd podczas usuwania producenta, skontaktuj się z administratorem');
    },
    getRouteToEdit: function getRouteToEdit(producer) {
      return {
        name: 'ProducerEdit',
        params: {
          id: producer.id
        }
      };
    },
    fetchData: function fetchData() {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].producer.getList().then(this.fetchSuccess);
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].producerList.get().then(this.fetchContentSuccess);
    },
    fetchSuccess: function fetchSuccess(_ref) {
      var body = _ref.body;

      this.producers = body;
    },
    fetchContentSuccess: function fetchContentSuccess(_ref2) {
      var body = _ref2.body;

      this.producerList = body;
    }
  },
  computed: {
    getRouteToAdd: function getRouteToAdd() {
      return {
        name: 'ProducerAdd'
      };
    }
  },
  created: function created() {
    this.fetchData();
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormGroup_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FormGroup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextInput_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TextInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FileInput_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FileInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FileInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MediaInput_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MediaInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MediaInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TextareaInput_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TextareaInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TextareaInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SubmitButton_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SubmitButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SubmitButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SelectInput_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SelectInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__SelectInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TableInput_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TableInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__TableInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Flash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_select__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers__ = __webpack_require__(79);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    id: { type: [String, Number] }
  },
  components: {
    FormGroup: __WEBPACK_IMPORTED_MODULE_1__FormGroup_vue___default.a,
    TextInput: __WEBPACK_IMPORTED_MODULE_2__TextInput_vue___default.a,
    FileInput: __WEBPACK_IMPORTED_MODULE_3__FileInput_vue___default.a,
    MediaInput: __WEBPACK_IMPORTED_MODULE_4__MediaInput_vue___default.a,
    TextareaInput: __WEBPACK_IMPORTED_MODULE_5__TextareaInput_vue___default.a,
    SubmitButton: __WEBPACK_IMPORTED_MODULE_6__SubmitButton_vue___default.a,
    SelectInput: __WEBPACK_IMPORTED_MODULE_7__SelectInput_vue___default.a,
    TableInput: __WEBPACK_IMPORTED_MODULE_8__TableInput_vue___default.a,
    vSelect: __WEBPACK_IMPORTED_MODULE_11_vue_select___default.a,
    Api: __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */]
  },
  data: function data() {
    return {
      submitting: false,
      product: {
        name: '',
        variety: '',
        origin: 'kraj',
        unit: ''
      },
      originOptions: __WEBPACK_IMPORTED_MODULE_12__helpers__["a" /* origins */],
      errors: []
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.errors = [];
      this.submitting = true;
      var product = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.product);
      __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].product.post(product).then(this.updateSuccess, this.updateError).then(function () {
        _this.submitting = false;
      });
    },
    updateSuccess: function updateSuccess() {
      __WEBPACK_IMPORTED_MODULE_10__Flash__["a" /* default */].success('Zapisano zmiany poprawnie');
      this.$router.push({
        name: 'Records'
      });
    },
    updateError: function updateError(_ref) {
      var _this2 = this;

      var body = _ref.body;

      var violations = body.violations;
      violations.forEach(function (violation) {
        _this2.errors[violation.propertyPath] = violation.message;
      });
    }
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Flash__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      products: [],
      featured: []
    };
  },

  methods: {
    disabled: function disabled(product) {
      if (this.featured.includes(product.id)) {
        return false;
      }
      return this.featured.length >= 10;
    },
    fetchData: function fetchData() {
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].product.getList().then(this.fetchSuccess);
    },
    fetchSuccess: function fetchSuccess(_ref) {
      var body = _ref.body;

      this.products = body;
      this.featured = body.filter(function (p) {
        return p.featured;
      }).map(function (p) {
        return p.id;
      });
    },
    save: function save() {
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].product.updateFeatured(this.featured).then(this.onUpdated, this.onError);
    },
    onUpdated: function onUpdated(_ref2) {
      var body = _ref2.body;

      __WEBPACK_IMPORTED_MODULE_1__Flash__["a" /* default */].success('Zaktualizowano wyróżnienie produktów poprawnie.');
    },
    onError: function onError() {
      __WEBPACK_IMPORTED_MODULE_1__Flash__["a" /* default */].error('Nie udało się zaktualizować wyróżnień produktów, skontaktuj się z administratorem');
    }
  },
  created: function created() {
    this.fetchData();
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    question: { type: String, required: true }
  },
  methods: {
    confirm: function confirm() {
      if (window.confirm(this.question)) {
        this.$emit('click');
      }
    }
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormGroup_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FormGroup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextInput_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TextInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CurrencyInput_vue__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CurrencyInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CurrencyInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CheckboxInput_vue__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CheckboxInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CheckboxInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__QuestionButton_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__QuestionButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__QuestionButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TrashIcon_vue__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TrashIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__TrashIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PlusIcon_vue__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PlusIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__PlusIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MinusIcon_vue__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MinusIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__MinusIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ArrowLeftIcon_vue__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ArrowLeftIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ArrowLeftIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SaveIcon_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SaveIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__SaveIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SubmitButton_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SubmitButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__SubmitButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SelectInput_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SelectInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__SelectInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Flash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers__ = __webpack_require__(79);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    id: { type: [String, Number], required: true }
  },
  components: {
    FormGroup: __WEBPACK_IMPORTED_MODULE_1__FormGroup_vue___default.a,
    TextInput: __WEBPACK_IMPORTED_MODULE_2__TextInput_vue___default.a,
    CheckboxInput: __WEBPACK_IMPORTED_MODULE_4__CheckboxInput_vue___default.a,
    QuestionButton: __WEBPACK_IMPORTED_MODULE_5__QuestionButton_vue___default.a,
    TrashIcon: __WEBPACK_IMPORTED_MODULE_6__TrashIcon_vue___default.a,
    PlusIcon: __WEBPACK_IMPORTED_MODULE_7__PlusIcon_vue___default.a,
    MinusIcon: __WEBPACK_IMPORTED_MODULE_8__MinusIcon_vue___default.a,
    ArrowLeftIcon: __WEBPACK_IMPORTED_MODULE_9__ArrowLeftIcon_vue___default.a,
    CurrencyInput: __WEBPACK_IMPORTED_MODULE_3__CurrencyInput_vue___default.a,
    SaveIcon: __WEBPACK_IMPORTED_MODULE_10__SaveIcon_vue___default.a,
    SubmitButton: __WEBPACK_IMPORTED_MODULE_11__SubmitButton_vue___default.a,
    SelectInput: __WEBPACK_IMPORTED_MODULE_12__SelectInput_vue___default.a,
    Api: __WEBPACK_IMPORTED_MODULE_13__api__["a" /* default */]
  },
  data: function data() {
    return {
      originOptions: __WEBPACK_IMPORTED_MODULE_15__helpers__["a" /* origins */],
      submitting: false,
      focusedDraftPrice: null,
      record: {
        card: {
          slug: ''
        },
        product: {
          enabled: false,
          name: '',
          origin: '',
          unit: '',
          variety: ''
        },
        publicPrices: [],
        draftPrices: [],
        previousPrices: []
      },
      errors: []
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.errors = [];
      this.submitting = true;
      this.record.draftPrices = this.record.draftPrices.filter(function (p) {
        return p.price > 0;
      });
      __WEBPACK_IMPORTED_MODULE_13__api__["a" /* default */].record.update(this.id, this.record).then(this.updateSuccess, this.updateError).then(function () {
        _this.submitting = false;
      });
    },
    updateSuccess: function updateSuccess(_ref) {
      var body = _ref.body;

      this.record = body;
      __WEBPACK_IMPORTED_MODULE_14__Flash__["a" /* default */].success('Zapisano zmiany poprawnie');
    },
    archiveProductSuccess: function archiveProductSuccess(_ref2) {
      var body = _ref2.body;

      this.record.product = body;
      __WEBPACK_IMPORTED_MODULE_14__Flash__["a" /* default */].success('Produkt zarchiwizowano poprawnie');
    },
    unArchiveProductSuccess: function unArchiveProductSuccess(_ref3) {
      var body = _ref3.body;

      this.record.product = body;
      __WEBPACK_IMPORTED_MODULE_14__Flash__["a" /* default */].success('Produkt przywrócono poprawnie');
    },
    updateError: function updateError(_ref4) {
      var _this2 = this;

      var body = _ref4.body;

      var violations = body.violations;
      violations.forEach(function (violation) {
        _this2.errors[violation.propertyPath] = violation.message;
      });
    },
    fetchData: function fetchData() {
      __WEBPACK_IMPORTED_MODULE_13__api__["a" /* default */].record.get(this.id, this.fetchSuccess);
    },
    fetchSuccess: function fetchSuccess(_ref5) {
      var body = _ref5.body;

      this.record = body;
    },
    archiveProduct: function archiveProduct(product) {
      __WEBPACK_IMPORTED_MODULE_13__api__["a" /* default */].product.archive(product.id).then(this.archiveProductSuccess);
    },
    unArchiveProduct: function unArchiveProduct(product) {
      __WEBPACK_IMPORTED_MODULE_13__api__["a" /* default */].product.unArchive(product.id).then(this.unArchiveProductSuccess);
    },
    addDraftPrice: function addDraftPrice() {
      this.record.draftPrices.push({
        price: '0.00'
      });
    },
    removeDraftPrice: function removeDraftPrice(index) {
      this.record.draftPrices.splice(index, 1);
    },
    usePreviousPrices: function usePreviousPrices() {
      this.record.draftPrices = this.record.previousPrices.map(function (o) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, o);
      });
    },
    removeFocusedDraftPrice: function removeFocusedDraftPrice() {
      if (this.focusedDraftPrice) {
        this.removeDraftPrice(this.focusedDraftPrice);
      }
    },
    updateFocusedDraftPrice: function updateFocusedDraftPrice(index) {
      this.focusedDraftPrice = index;
    },
    focusPreviousDraftPrice: function focusPreviousDraftPrice() {
      if (this.focusedDraftPrice && this.focusedDraftPrice > 0) {
        this.focusedDraftPrice--;
      }
    },
    focusNextDraftPrice: function focusNextDraftPrice() {
      if (this.focusedDraftPrice && this.record.draftPrices.length > this.focusedDraftPrice) {
        this.focusedDraftPrice++;
      }
    },
    isDraftPriceFocused: function isDraftPriceFocused(index) {
      return this.focusedDraftPrice === index;
    }
  },
  computed: {
    emptyPreviousPrices: function emptyPreviousPrices() {
      return this.record.previousPrices.length === 0;
    }
  },
  created: function created() {
    this.fetchData();
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InfoIcon_vue__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InfoIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__InfoIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__QuestionButton_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__QuestionButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__QuestionButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Flash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CurrencyInput_vue__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CurrencyInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__CurrencyInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PlusIcon_vue__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PlusIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__PlusIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SaveIcon_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SaveIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__SaveIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MinusIcon_vue__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MinusIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__MinusIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DatePicker_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DatePicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__DatePicker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Flash__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    id: { type: String, default: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD') },
    search: { type: String, default: '' }
  },
  components: {
    InfoIcon: __WEBPACK_IMPORTED_MODULE_3__InfoIcon_vue___default.a,
    QuestionButton: __WEBPACK_IMPORTED_MODULE_4__QuestionButton_vue___default.a,
    CurrencyInput: __WEBPACK_IMPORTED_MODULE_6__CurrencyInput_vue___default.a,
    PlusIcon: __WEBPACK_IMPORTED_MODULE_7__PlusIcon_vue___default.a,
    SaveIcon: __WEBPACK_IMPORTED_MODULE_8__SaveIcon_vue___default.a,
    MinusIcon: __WEBPACK_IMPORTED_MODULE_9__MinusIcon_vue___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_10__DatePicker_vue___default.a
  },
  data: function data() {
    return {
      mode: 'view',
      localId: this.id,
      localSearch: this.search,
      card: {
        notifyLogs: []
      },
      notifying: false
    };
  },

  methods: {
    usePreviousCard: function usePreviousCard() {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].card.usePrevious(this.id).then(this.usePreviousSuccess, this.usePreviousError);
    },
    usePreviousSuccess: function usePreviousSuccess(_ref) {
      var body = _ref.body;

      body.records.forEach(function (r) {
        r.editModePrices = [];
        r.publicPrices.forEach(function (p) {
          r.editModePrices.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, p));
        });
      });
      this.card = body;
    },
    usePreviousError: function usePreviousError() {},
    sendNotifications: function sendNotifications() {
      var _this = this;

      this.notifying = true;
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].card.notify(this.id).then(this.onNotifySuccess, this.onNotifyError).then(function () {
        _this.notifying = false;
      });
    },
    onNotifySuccess: function onNotifySuccess(_ref2) {
      var body = _ref2.body;

      this.setCard(body);
      __WEBPACK_IMPORTED_MODULE_11__Flash__["a" /* default */].success('Powiadommienia zostały wysłane poprawnie');
    },
    onNotifyError: function onNotifyError(_ref3) {
      var status = _ref3.status;

      if (status === 422) {
        __WEBPACK_IMPORTED_MODULE_11__Flash__["a" /* default */].error('Nie wszystkie ceny zostały opublikowane.');
      } else {
        __WEBPACK_IMPORTED_MODULE_11__Flash__["a" /* default */].error('Wystąpił nieoczekiwany błąd podczas wysłania powiadomień - skontaktuj się z administratorem');
      }
    },
    setViewMode: function setViewMode() {
      this.mode = 'view';
    },
    saveEditModePrices: function saveEditModePrices() {
      var _this2 = this;

      this.card.records.map(function (r) {
        if (r.editModePrices.length > 0) {
          r.draftPrices = [];
          r.editModePrices.forEach(function (p) {
            if (r.editModePrices.length === 1 && p.price === '0.00' || p.price > 0) {
              delete p.id;
              r.draftPrices.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, p));
            }
          });
          r.editModePrices = [];
        }
      });
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].card.put(this.id, this.card).then(function (_ref4) {
        var body = _ref4.body;
        _this2.setCard(body);
      });
      this.setViewMode();
    },
    addEditModePriceTo: function addEditModePriceTo(record) {
      record.editModePrices.push({
        price: '0.00'
      });
    },
    removeEditModePrice: function removeEditModePrice(record, index) {
      record.editModePrices.splice(index, 1);
    },
    setEditMode: function setEditMode() {
      this.mode = 'edit';
    },
    unsetEditMode: function unsetEditMode() {
      this.mode = 'view';
    },
    goToEdit: function goToEdit(record) {
      this.$router.push({
        name: 'RecordEdit',
        params: {
          id: record.id
        }
      });
    },
    publish: function publish() {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].card.publish(this.id).then(this.publishSuccess, this.publishError);
    },
    publishSuccess: function publishSuccess(_ref5) {
      var body = _ref5.body;

      this.setCard(body);
      __WEBPACK_IMPORTED_MODULE_5__Flash__["a" /* default */].success('Opublikowano zmiany w notowaniach poprawnie');
    },
    publishError: function publishError() {
      __WEBPACK_IMPORTED_MODULE_5__Flash__["a" /* default */].error('Wystąpił błąd podczas publikowania zmian w notowaniach, skontaktuj się z administratorem');
    },
    update: function update() {
      this.$router.push({
        name: 'Records',
        params: {
          id: this.localId,
          search: this.localSearch || undefined
        }
      });
    },
    fetchData: function fetchData() {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].card.get(this.id, this.fetchSuccess);
    },
    setCard: function setCard(body) {
      body.records.forEach(function (r) {
        r.editModePrices = [];
      });
      this.card = body;
    },
    fetchSuccess: function fetchSuccess(_ref6) {
      var body = _ref6.body;

      this.setCard(body);
    }
  },
  computed: {
    notifyQuestion: function notifyQuestion() {
      var txt = 'Czy na pewno wysłać powiadomienia do klientów o nowych cenach?';
      var dates = this.card.notifyLogs.join(', ');
      if (dates) {
        return 'UWAGA! Powiadomienia by\u0142y wys\u0142ane ju\u017C o: ' + dates + '. ' + txt;
      }
      return txt;
    },
    getRecordsWithEditModePrices: function getRecordsWithEditModePrices() {
      return this.card.records.filter(function (r) {
        return r.editModePrices.length > 0;
      });
    },
    showSaveEditModeButton: function showSaveEditModeButton() {
      return this.getRecordsWithEditModePrices.length > 0;
    },
    showChangesAlert: function showChangesAlert() {
      return this.card.records && this.card.records.filter(function (r) {
        return r.draftPrices.length > 0;
      }).length > 0;
    },
    viewMode: function viewMode() {
      return this.mode === 'view';
    },
    editMode: function editMode() {
      return this.mode === 'edit';
    }
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData',
    date: function date(val) {
      this.localId = val;
    },
    search: function search(val) {
      this.localSearch = val;
    }
  },
  created: function created() {
    this.fetchData();
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SubmitButton_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SubmitButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SubmitButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormGroup_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FormGroup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextareaInput_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextareaInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TextareaInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Flash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      errors: [],
      submitting: false,
      regulation: {
        content: ''
      }
    };
  },

  components: {
    SubmitButton: __WEBPACK_IMPORTED_MODULE_0__SubmitButton_vue___default.a,
    FormGroup: __WEBPACK_IMPORTED_MODULE_1__FormGroup_vue___default.a,
    TextareaInput: __WEBPACK_IMPORTED_MODULE_2__TextareaInput_vue___default.a
  },
  methods: {
    submit: function submit() {
      var _this = this;

      this.errors = [];
      this.submitting = true;
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].regulation.put(this.regulation).then(this.onSubmitSuccess, this.updateError).then(function () {
        _this.submitting = false;
      });
    },
    onSubmitSuccess: function onSubmitSuccess() {
      __WEBPACK_IMPORTED_MODULE_3__Flash__["a" /* default */].success('Zaktualizowano regulamin poprawnie');
    },
    updateError: function updateError() {
      __WEBPACK_IMPORTED_MODULE_3__Flash__["a" /* default */].error('Niestety nie udało się zaktualizować regulaminu, skontaktuj się z administratorem');
    },
    fetchData: function fetchData() {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].regulation.get().then(this.fetchSuccess);
    },
    fetchSuccess: function fetchSuccess(_ref) {
      var body = _ref.body;

      this.regulation = body;
    }
  },
  created: function created() {
    this.fetchData();
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: { required: true },
    options: { type: Array, required: true }
  },
  data: function data() {
    return {
      localValue: this.value
    };
  },

  watch: {
    localValue: function localValue(newVal) {
      this.$emit('input', newVal);
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      defaultDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD')
    };
  },

  computed: {
    recordsRoute: function recordsRoute() {
      return {
        name: 'Records',
        params: {
          id: this.defaultDate
        }
      };
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SaveIcon_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SaveIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SaveIcon_vue__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    submitting: { type: Boolean, required: true }
  },
  components: {
    SaveIcon: __WEBPACK_IMPORTED_MODULE_0__SaveIcon_vue___default.a
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: { required: true },
    options: { type: Array, required: true }
  },
  data: function data() {
    return {
      localValue: this.value
    };
  },

  watch: {
    localValue: function localValue(newVal) {
      this.$emit('input', newVal);
    }
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: { required: true }
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: { required: true }
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TopHeader',
  methods: {
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_0__auth__["a" /* default */].logout();
      window.location.reload();
    },
    toggleMenu: function toggleMenu() {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.menu = !__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.menu;
    }
  },
  computed: {
    menu: function menu() {
      return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.menu;
    }
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BooleanState_vue__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BooleanState_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__BooleanState_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tiny_debounce__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tiny_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_tiny_debounce__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      search: '',
      packet: '',
      type: '',
      users: []
    };
  },

  components: {
    BooleanState: __WEBPACK_IMPORTED_MODULE_1__BooleanState_vue___default.a
  },
  methods: {
    resendActivation: function resendActivation(user) {
      user.sending = true;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].user.resendActivation(user.id).then(function () {
        user.sending = false;
      });
    },
    nullToBool: function nullToBool(value) {
      if (!value) {
        return false;
      }
      return true;
    },
    fetchData: function fetchData(search, packet, type) {
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].user.getList(search, packet, type).then(this.onGetListSuccess);
    },
    onGetListSuccess: function onGetListSuccess(_ref) {
      var body = _ref.body;

      this.users = body;
    },
    getRouteToChangePackage: function getRouteToChangePackage(user) {
      return {
        name: 'ChangePackage',
        params: {
          id: user.id
        }
      };
    },

    debounceSearch: __WEBPACK_IMPORTED_MODULE_2_tiny_debounce___default()(function () {
      this.fetchData(this.search, this.packet, this.type);
    }, 500)
  },
  watch: {
    '$route': 'fetchData',
    'search': 'debounceSearch',
    'packet': 'debounceSearch',
    'type': 'debounceSearch'
  },
  created: function created() {
    this.fetchData();
  }
});

/***/ }),
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 124,
	"./af.js": 124,
	"./ar": 131,
	"./ar-dz": 125,
	"./ar-dz.js": 125,
	"./ar-kw": 126,
	"./ar-kw.js": 126,
	"./ar-ly": 127,
	"./ar-ly.js": 127,
	"./ar-ma": 128,
	"./ar-ma.js": 128,
	"./ar-sa": 129,
	"./ar-sa.js": 129,
	"./ar-tn": 130,
	"./ar-tn.js": 130,
	"./ar.js": 131,
	"./az": 132,
	"./az.js": 132,
	"./be": 133,
	"./be.js": 133,
	"./bg": 134,
	"./bg.js": 134,
	"./bn": 135,
	"./bn.js": 135,
	"./bo": 136,
	"./bo.js": 136,
	"./br": 137,
	"./br.js": 137,
	"./bs": 138,
	"./bs.js": 138,
	"./ca": 139,
	"./ca.js": 139,
	"./cs": 140,
	"./cs.js": 140,
	"./cv": 141,
	"./cv.js": 141,
	"./cy": 142,
	"./cy.js": 142,
	"./da": 143,
	"./da.js": 143,
	"./de": 146,
	"./de-at": 144,
	"./de-at.js": 144,
	"./de-ch": 145,
	"./de-ch.js": 145,
	"./de.js": 146,
	"./dv": 147,
	"./dv.js": 147,
	"./el": 148,
	"./el.js": 148,
	"./en-au": 149,
	"./en-au.js": 149,
	"./en-ca": 150,
	"./en-ca.js": 150,
	"./en-gb": 151,
	"./en-gb.js": 151,
	"./en-ie": 152,
	"./en-ie.js": 152,
	"./en-nz": 153,
	"./en-nz.js": 153,
	"./eo": 154,
	"./eo.js": 154,
	"./es": 156,
	"./es-do": 155,
	"./es-do.js": 155,
	"./es.js": 156,
	"./et": 157,
	"./et.js": 157,
	"./eu": 158,
	"./eu.js": 158,
	"./fa": 159,
	"./fa.js": 159,
	"./fi": 160,
	"./fi.js": 160,
	"./fo": 161,
	"./fo.js": 161,
	"./fr": 164,
	"./fr-ca": 162,
	"./fr-ca.js": 162,
	"./fr-ch": 163,
	"./fr-ch.js": 163,
	"./fr.js": 164,
	"./fy": 165,
	"./fy.js": 165,
	"./gd": 166,
	"./gd.js": 166,
	"./gl": 167,
	"./gl.js": 167,
	"./gom-latn": 168,
	"./gom-latn.js": 168,
	"./he": 169,
	"./he.js": 169,
	"./hi": 170,
	"./hi.js": 170,
	"./hr": 171,
	"./hr.js": 171,
	"./hu": 172,
	"./hu.js": 172,
	"./hy-am": 173,
	"./hy-am.js": 173,
	"./id": 174,
	"./id.js": 174,
	"./is": 175,
	"./is.js": 175,
	"./it": 176,
	"./it.js": 176,
	"./ja": 177,
	"./ja.js": 177,
	"./jv": 178,
	"./jv.js": 178,
	"./ka": 179,
	"./ka.js": 179,
	"./kk": 180,
	"./kk.js": 180,
	"./km": 181,
	"./km.js": 181,
	"./kn": 182,
	"./kn.js": 182,
	"./ko": 183,
	"./ko.js": 183,
	"./ky": 184,
	"./ky.js": 184,
	"./lb": 185,
	"./lb.js": 185,
	"./lo": 186,
	"./lo.js": 186,
	"./lt": 187,
	"./lt.js": 187,
	"./lv": 188,
	"./lv.js": 188,
	"./me": 189,
	"./me.js": 189,
	"./mi": 190,
	"./mi.js": 190,
	"./mk": 191,
	"./mk.js": 191,
	"./ml": 192,
	"./ml.js": 192,
	"./mr": 193,
	"./mr.js": 193,
	"./ms": 195,
	"./ms-my": 194,
	"./ms-my.js": 194,
	"./ms.js": 195,
	"./my": 196,
	"./my.js": 196,
	"./nb": 197,
	"./nb.js": 197,
	"./ne": 198,
	"./ne.js": 198,
	"./nl": 200,
	"./nl-be": 199,
	"./nl-be.js": 199,
	"./nl.js": 200,
	"./nn": 201,
	"./nn.js": 201,
	"./pa-in": 202,
	"./pa-in.js": 202,
	"./pl": 203,
	"./pl.js": 203,
	"./pt": 205,
	"./pt-br": 204,
	"./pt-br.js": 204,
	"./pt.js": 205,
	"./ro": 206,
	"./ro.js": 206,
	"./ru": 207,
	"./ru.js": 207,
	"./sd": 208,
	"./sd.js": 208,
	"./se": 209,
	"./se.js": 209,
	"./si": 210,
	"./si.js": 210,
	"./sk": 211,
	"./sk.js": 211,
	"./sl": 212,
	"./sl.js": 212,
	"./sq": 213,
	"./sq.js": 213,
	"./sr": 215,
	"./sr-cyrl": 214,
	"./sr-cyrl.js": 214,
	"./sr.js": 215,
	"./ss": 216,
	"./ss.js": 216,
	"./sv": 217,
	"./sv.js": 217,
	"./sw": 218,
	"./sw.js": 218,
	"./ta": 219,
	"./ta.js": 219,
	"./te": 220,
	"./te.js": 220,
	"./tet": 221,
	"./tet.js": 221,
	"./th": 222,
	"./th.js": 222,
	"./tl-ph": 223,
	"./tl-ph.js": 223,
	"./tlh": 224,
	"./tlh.js": 224,
	"./tr": 225,
	"./tr.js": 225,
	"./tzl": 226,
	"./tzl.js": 226,
	"./tzm": 228,
	"./tzm-latn": 227,
	"./tzm-latn.js": 227,
	"./tzm.js": 228,
	"./uk": 229,
	"./uk.js": 229,
	"./ur": 230,
	"./ur.js": 230,
	"./uz": 232,
	"./uz-latn": 231,
	"./uz-latn.js": 231,
	"./uz.js": 232,
	"./vi": 233,
	"./vi.js": 233,
	"./x-pseudo": 234,
	"./x-pseudo.js": 234,
	"./yo": 235,
	"./yo.js": 235,
	"./zh-cn": 236,
	"./zh-cn.js": 236,
	"./zh-hk": 237,
	"./zh-hk.js": 237,
	"./zh-tw": 238,
	"./zh-tw.js": 238
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 383;

/***/ }),
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.7b9155a.png";

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(429),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(451),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(343)
}
var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(467),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(453),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(436),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(446),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(457),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(445),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(425),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(442),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(341)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(449),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(441),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(342)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(458),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(460),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(462),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(450),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(452),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(468),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(428),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(454),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(444),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(463),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(438),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(434),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(459),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(456),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(338)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(430),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(455),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 424 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.confirm($event)
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "glyphicon glyphicon-info-sign"
  })
},staticRenderFns: []}

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    staticClass: "form-control",
    attrs: {
      "onfocus": "this.select()"
    },
    domProps: {
      "value": _vm.formattedValue
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.update($event)
      },
      "blur": _vm.update
    }
  })
},staticRenderFns: []}

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.checked
    },
    on: {
      "change": _vm.change
    }
  }), _vm._v(" "), (_vm.label) ? [_vm._v("\n    " + _vm._s(_vm.label) + "\n    ")] : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("Dane ogólne")]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Nazwa",
      "error": _vm.errors['name']
    }
  }, [_c('text-input', {
    model: {
      value: (_vm.producer.name),
      callback: function($$v) {
        _vm.producer.name = $$v
      },
      expression: "producer.name"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Link",
      "error": _vm.errors['link']
    }
  }, [_c('text-input', {
    model: {
      value: (_vm.producer.link),
      callback: function($$v) {
        _vm.producer.link = $$v
      },
      expression: "producer.link"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Opis",
      "error": _vm.errors['description']
    }
  }, [_c('textarea-input', {
    attrs: {
      "rows": "5"
    },
    model: {
      value: (_vm.producer.description),
      callback: function($$v) {
        _vm.producer.description = $$v
      },
      expression: "producer.description"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Godziny otwarcia",
      "error": _vm.errors['openingHours']
    }
  }, [_c('textarea-input', {
    attrs: {
      "rows": "5"
    },
    model: {
      value: (_vm.producer.openingHours),
      callback: function($$v) {
        _vm.producer.openingHours = $$v
      },
      expression: "producer.openingHours"
    }
  })], 1)], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Produkty producenta")]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Produkty",
      "error": _vm.errors['products']
    }
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.productsOptions
    },
    model: {
      value: (_vm.producer.products),
      callback: function($$v) {
        _vm.producer.products = $$v
      },
      expression: "producer.products"
    }
  })], 1)], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Logo")]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Logo",
      "error": _vm.errors['logo']
    }
  }, [_c('media-input', {
    model: {
      value: (_vm.producer.logo),
      callback: function($$v) {
        _vm.producer.logo = $$v
      },
      expression: "producer.logo"
    }
  })], 1)], 1), _vm._v(" "), _c('submit-button', {
    attrs: {
      "submitting": _vm.submitting
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "glyphicon glyphicon-arrow-left"
  })
},staticRenderFns: []}

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "row",
    staticStyle: {
      "line-height": "46px",
      "padding-left": "15px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleMenu($event)
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-menu-hamburger"
  }), _vm._v(" "), (_vm.menu) ? [_vm._v("Ukryj menu")] : _vm._e(), _vm._v(" "), (!_vm.menu) ? [_vm._v("Pokaż menu")] : _vm._e()], 2), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_c('img', {
    attrs: {
      "id": "logo",
      "src": __webpack_require__(395),
      "alt": "",
      "height": "40"
    }
  })]), _vm._v("\n  - panel administracyjny\n  "), _c('button', {
    staticClass: "btn btn-primary btn-lg pull-right",
    attrs: {
      "title": "Wyloguj"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-off"
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.submitting
    }
  }, [_c('save-icon'), _vm._v(" "), (_vm.submitting) ? [_vm._v("Zapisuję...")] : [_vm._v("Zapisz")]], 2)
},staticRenderFns: []}

/***/ }),
/* 432 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    staticClass: "form-control",
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "glyphicon glyphicon-trash"
  })
},staticRenderFns: []}

/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Lista notowań")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('date-picker', {
    on: {
      "input": _vm.update
    },
    model: {
      value: (_vm.localId),
      callback: function($$v) {
        _vm.localId = $$v
      },
      expression: "localId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary spaced",
    attrs: {
      "to": {
        name: 'ProductAdd'
      }
    }
  }, [_vm._v("Dodaj produkt")]), _vm._v(" "), (_vm.showChangesAlert) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('strong', [_c('info-icon'), _vm._v("\n          Informacja\n          "), _c('br')], 1), _vm._v("\n        Wprowadzono zmiany w notowaniach\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('question-button', {
    staticClass: "btn btn-info pull-right",
    attrs: {
      "question": "Czy na pewno opublikować zmiany cen?"
    },
    on: {
      "click": _vm.publish
    }
  }, [_vm._v("Opublikuj\n        ")])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spaced"
  }, [_c('question-button', {
    staticClass: "pull-left btn btn-default",
    attrs: {
      "question": _vm.notifyQuestion
    },
    on: {
      "click": _vm.sendNotifications
    }
  }, [_vm._v("\n      Wyślij powiadomienia\n    ")]), _vm._v(" "), (_vm.viewMode) ? _c('button', {
    staticClass: "pull-right btn btn-default",
    on: {
      "click": _vm.setEditMode
    }
  }, [_vm._v("\n      Aktualizuj wszystkie\n    ")]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('button', {
    staticClass: "pull-right btn btn-default",
    on: {
      "click": _vm.unsetEditMode
    }
  }, [_vm._v("\n      Anuluj\n    ")]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('button', {
    staticClass: "pull-right btn btn-info",
    on: {
      "click": _vm.usePreviousCard
    }
  }, [_vm._v("\n      Użyj poprzednich notowań\n    ")]) : _vm._e(), _vm._v(" "), (_vm.editMode && _vm.showSaveEditModeButton) ? _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": _vm.saveEditModePrices
    }
  }, [_c('save-icon'), _vm._v("\n      Zapisz\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.editMode && _vm.showSaveEditModeButton) ? _c('button', {
    staticClass: "pull-right btn btn-default",
    on: {
      "click": _vm.setViewMode
    }
  }, [_vm._v("\n      Anuluj\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.card.records), function(record) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(record.product.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.product.variety))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.product.origin))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.product.enabled))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.product.unit))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "pull-left"
    }, [_vm._l((record.publicPrices), function(price) {
      return [_vm._v("\n          " + _vm._s(_vm._f("currency")(price.price)) + " "), _c('br')]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "pull-right",
      staticStyle: {
        "max-width": "100px"
      }
    }, [_vm._l((record.draftPrices), function(price) {
      return _c('span', {
        staticClass: "draft-price"
      }, [_vm._v("\n            " + _vm._s(_vm._f("currency")(price.price)) + " "), _c('br')])
    }), _vm._v(" "), _vm._l((record.editModePrices), function(price, index) {
      return (_vm.editMode) ? _c('div', {
        staticClass: "input-group input-group-sm"
      }, [_c('currency-input', {
        staticClass: "input-sm",
        model: {
          value: (price.price),
          callback: function($$v) {
            price.price = $$v
          },
          expression: "price.price"
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "input-group-btn"
      }, [_c('button', {
        staticClass: "btn btn-danger",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.removeEditModePrice(record, index)
          }
        }
      }, [_c('minus-icon')], 1)])], 1) : _vm._e()
    }), _vm._v(" "), (_vm.editMode) ? _c('button', {
      staticClass: "btn btn-info btn-sm",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "button",
        "title": "Dodaj nową cenę"
      },
      on: {
        "click": function($event) {
          _vm.addEditModePriceTo(record)
        }
      }
    }, [_c('plus-icon'), _vm._v("\n            dodaj cenę\n          ")], 1) : _vm._e()], 2)]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "pull-left"
    }, [_vm._v("\n          " + _vm._s(_vm._f("currency")(record.publicAvgPrice)) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [(record.draftPrices.length > 0) ? _c('span', {
      staticClass: "draft-price"
    }, [_vm._v("\n            " + _vm._s(_vm._f("currency")(record.draftAvgPrice)) + "\n          ")]) : _vm._e()])]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'RecordEdit',
          params: {
            id: record.id
          }
        }
      }
    }, [_vm._v("edytuj")])], 1)])
  }))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Produkt")]), _vm._v(" "), _c('th', [_vm._v("Odmiana")]), _vm._v(" "), _c('th', [_vm._v("Pochodzenie")]), _vm._v(" "), _c('th', [_vm._v("Dostępność")]), _vm._v(" "), _c('th', [_vm._v("Jednostka")]), _vm._v(" "), _c('th', [_vm._v("Ceny")]), _vm._v(" "), _c('th', [_vm._v("Cena średnia")]), _vm._v(" "), _c('th')])])
}]}

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "datepicker",
    staticClass: "form-control",
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Kontakt")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('form-group', {
    attrs: {
      "label": "Dane firmy",
      "error": _vm.errors['contact.companyData']
    }
  }, [_c('textarea-input', {
    attrs: {
      "rows": "10"
    },
    model: {
      value: (_vm.contact.companyData),
      callback: function($$v) {
        _vm.contact.companyData = $$v
      },
      expression: "contact.companyData"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Telefony",
      "error": _vm.errors['contact.phonesData']
    }
  }, [_c('textarea-input', {
    attrs: {
      "rows": "10"
    },
    model: {
      value: (_vm.contact.phonesData),
      callback: function($$v) {
        _vm.contact.phonesData = $$v
      },
      expression: "contact.phonesData"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Email do wiadomości",
      "error": _vm.errors['contact.contactEmail']
    }
  }, [_c('text-input', {
    model: {
      value: (_vm.contact.contactEmail),
      callback: function($$v) {
        _vm.contact.contactEmail = $$v
      },
      expression: "contact.contactEmail"
    }
  })], 1), _vm._v(" "), _c('submit-button', {
    attrs: {
      "submitting": _vm.submitting
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "glyphicon glyphicon-minus-sign"
  })
},staticRenderFns: []}

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("Edycja notowania")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": _vm.record.card.slug
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(!_vm.record.product.archived) ? _c('question-button', {
    staticClass: "btn btn-danger pull-right",
    attrs: {
      "question": "Czy na pewno zarchiwizować produkt?"
    },
    on: {
      "click": function($event) {
        _vm.archiveProduct(_vm.record.product)
      }
    }
  }, [_c('trash-icon'), _vm._v("\n            Archiwizuj produkt\n          ")], 1) : _vm._e(), _vm._v(" "), (_vm.record.product.archived) ? _c('question-button', {
    staticClass: "btn btn-warning pull-right",
    attrs: {
      "question": "Czy na pewno przywrócić produkt?"
    },
    on: {
      "click": function($event) {
        _vm.unArchiveProduct(_vm.record.product)
      }
    }
  }, [_c('trash-icon'), _vm._v("\n            Przywróć produkt\n          ")], 1) : _vm._e()], 1)])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Dane ogólne")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('form-group', {
    attrs: {
      "label": "Nazwa",
      "error": _vm.errors['product.name']
    }
  }, [_c('text-input', {
    model: {
      value: (_vm.record.product.name),
      callback: function($$v) {
        _vm.record.product.name = $$v
      },
      expression: "record.product.name"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Odmiana"
    }
  }, [_c('text-input', {
    model: {
      value: (_vm.record.product.variety),
      callback: function($$v) {
        _vm.record.product.variety = $$v
      },
      expression: "record.product.variety"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "offset-col": 2
    }
  }, [_c('checkbox-input', {
    attrs: {
      "label": "Dostępność"
    },
    model: {
      value: (_vm.record.product.enabled),
      callback: function($$v) {
        _vm.record.product.enabled = $$v
      },
      expression: "record.product.enabled"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('form-group', {
    attrs: {
      "label": "Pochodzenie",
      "error": _vm.errors['product.origin']
    }
  }, [_c('select-input', {
    attrs: {
      "options": _vm.originOptions
    },
    model: {
      value: (_vm.record.product.origin),
      callback: function($$v) {
        _vm.record.product.origin = $$v
      },
      expression: "record.product.origin"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Jednostka",
      "error": _vm.errors['product.unit']
    }
  }, [_c('text-input', {
    model: {
      value: (_vm.record.product.unit),
      callback: function($$v) {
        _vm.record.product.unit = $$v
      },
      expression: "record.product.unit"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('fieldset', [_c('legend', [_vm._v("Aktualne ceny (opublikowane)")]), _vm._v(" "), _vm._l((_vm.record.publicPrices), function(price, index) {
    return _c('form-group', {
      key: index
    }, [_c('currency-input', {
      attrs: {
        "disabled": ""
      },
      model: {
        value: (price.price),
        callback: function($$v) {
          price.price = $$v
        },
        expression: "price.price"
      }
    })], 1)
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('fieldset', [_c('legend', [_vm._v("Aktualizacja cen (ceny do publkacji)")]), _vm._v(" "), _vm._l((_vm.record.draftPrices), function(price, index) {
    return _c('form-group', {
      key: index
    }, [_c('currency-input', {
      attrs: {
        "focused": _vm.isDraftPriceFocused(index)
      },
      nativeOn: {
        "keydown": [function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "plus")) { return null; }
          $event.preventDefault();
          _vm.addDraftPrice($event)
        }, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "minus")) { return null; }
          $event.preventDefault();
          _vm.removeFocusedDraftPrice($event)
        }, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
          $event.preventDefault();
          _vm.focusPreviousDraftPrice($event)
        }, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
          $event.preventDefault();
          _vm.focusNextDraftPrice($event)
        }],
        "focus": function($event) {
          _vm.updateFocusedDraftPrice(index)
        }
      },
      model: {
        value: (price.price),
        callback: function($$v) {
          price.price = $$v
        },
        expression: "price.price"
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.removeDraftPrice(index)
        }
      },
      slot: "addon"
    }, [_c('minus-icon')], 1)], 1)
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addDraftPrice
    }
  }, [_c('plus-icon'), _vm._v("\n            Dodaj cenę\n          ")], 1)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('fieldset', [_c('legend', [_vm._v("Ceny z poprzedniego notowania")]), _vm._v(" "), _vm._l((_vm.record.previousPrices), function(price, index) {
    return _c('form-group', {
      key: index
    }, [_c('currency-input', {
      attrs: {
        "disabled": ""
      },
      model: {
        value: (price.price),
        callback: function($$v) {
          price.price = $$v
        },
        expression: "price.price"
      }
    })], 1)
  }), _vm._v(" "), (_vm.emptyPreviousPrices) ? _c('p', [_vm._v("Brak cen z poprzedniego notowania")]) : _c('div', [_c('question-button', {
    staticClass: "btn btn-default",
    attrs: {
      "question": "Czy na pewno użyć cen z wczoraj?"
    },
    on: {
      "click": _vm.usePreviousPrices
    }
  }, [_c('arrow-left-icon'), _vm._v("\n              Użyj dzisiaj\n            ")], 1)], 1)], 2)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('submit-button', {
    attrs: {
      "submitting": _vm.submitting
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.hasError
    }
  }, [(_vm.label) ? _c('label', {
    staticClass: "control-label",
    class: ( _obj = {}, _obj[_vm.labelClass] = _vm.horizontal, _obj )
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.controlClasses
  }, [_c('div', {
    class: _vm.inputGroupClasses
  }, [_vm._t("default"), _vm._v(" "), (_vm.hasAddon) ? _c('span', {
    staticClass: "input-group-btn"
  }, [_vm._t("addon")], 2) : _vm._e()], 2), _vm._v(" "), (_vm.hasError) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])])
  var _obj;
},staticRenderFns: []}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue),
      expression: "localValue"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.localValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  }))
},staticRenderFns: []}

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [(_vm.media) ? _c('div', [_c('div', {
    staticClass: "thumbnail"
  }, [_c('a', {
    attrs: {
      "href": _vm.media.filepath,
      "target": "_blank",
      "title": "Otwórz w nowym oknie"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.media.filepath
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.media.filename) + "\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('change')
      }
    }
  }, [_vm._v("Zmień")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('delete', _vm.media)
      }
    }
  }, [_vm._v("Usuń")])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "10px",
      "left": "10px",
      "right": "10px",
      "background-color": "#ddd"
    }
  }, [_c('button', {
    staticClass: "btn btn-default pull-right",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("Zamknij")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.media.filepath,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.media.filepath
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "glyphicon glyphicon-floppy-disk"
  })
},staticRenderFns: []}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('fieldset', [_c('legend'), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Nazwa",
      "error": _vm.errors['name']
    }
  }, [_c('text-input', {
    model: {
      value: (_vm.product.name),
      callback: function($$v) {
        _vm.product.name = $$v
      },
      expression: "product.name"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Odmiana",
      "error": _vm.errors['variety']
    }
  }, [_c('text-input', {
    model: {
      value: (_vm.product.variety),
      callback: function($$v) {
        _vm.product.variety = $$v
      },
      expression: "product.variety"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Pochodzenie",
      "error": _vm.errors['origin']
    }
  }, [_c('select-input', {
    attrs: {
      "options": _vm.originOptions
    },
    model: {
      value: (_vm.product.origin),
      callback: function($$v) {
        _vm.product.origin = $$v
      },
      expression: "product.origin"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Jednostka",
      "error": _vm.errors['unit']
    }
  }, [_c('text-input', {
    model: {
      value: (_vm.product.unit),
      callback: function($$v) {
        _vm.product.unit = $$v
      },
      expression: "product.unit"
    }
  })], 1)], 1), _vm._v(" "), _c('submit-button', {
    attrs: {
      "submitting": _vm.submitting
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form-data', {
    attrs: {
      "url": "api/homepages/1",
      "method": "PUT",
      "form": _vm.form
    },
    on: {
      "success": _vm.onSubmitSuccess
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  Dashboard\n")])
},staticRenderFns: []}

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea', {
    staticClass: "form-control",
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.value))])
},staticRenderFns: []}

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "loader"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/loader.gif",
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.authenticated) ? _c('top-header') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.authenticated) ? _c('div', {
    class: _vm.sidebarClasses
  }, [_c('sidebar')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.containerClasses
  }, [_c('router-view')], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewport"
  }, [_c('center-header', [_vm._v("Logowanie")]), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('form-group', {
    attrs: {
      "label": "login",
      "stacked": ""
    }
  }, [_c('text-input', {
    attrs: {
      "autofocus": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "hasło",
      "stacked": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "disabled": _vm.logging
    }
  }, [(_vm.logging) ? [_vm._v("Logowanie...")] : [_vm._v("Zaloguj")]], 2)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label",
    class: _vm.classes
  }, [_vm._v("\n  " + _vm._s(_vm.stateForHuman) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label",
    class: _vm.classes
  }, [_vm._v("\n  " + _vm._s(_vm.stateForHuman) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Płatności")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Wyszukaj email...",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover table-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.payments), function(payment) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("date")(payment.createdAt)))]), _vm._v(" "), _c('td', [_vm._v("\n        " + _vm._s(payment.order.planDefinition.name) + " "), _c('br'), _vm._v("\n        na " + _vm._s(payment.order.periodForHuman) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(payment.order.user.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(payment.order.user.phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(payment.order.paymentMethod.name))]), _vm._v(" "), _c('td', [_c('payment-state', {
      attrs: {
        "state": payment.order.state
      }
    })], 1), _vm._v(" "), _c('td', [(payment.order.state !== 'realized') ? _c('question-button', {
      staticClass: "btn btn-default",
      attrs: {
        "question": "Czy na pewno oznaczyć opłacenie i zrealizować zamówienie?"
      },
      on: {
        "click": function($event) {
          _vm.setAsPaid(payment)
        }
      }
    }, [_vm._v("\n          Oznacz opłacenie\n        ")]) : _vm._e()], 1)])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Data płatności")]), _vm._v(" "), _c('th', [_vm._v("Pakiet")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Telefon")]), _vm._v(" "), _c('th', [_vm._v("Forma płatności")]), _vm._v(" "), _c('th', [_vm._v("Zapłacono")]), _vm._v(" "), _c('th')])])
}]}

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Zmiana pakietu")]), _vm._v(" "), _c('form', {
    staticClass: "form-inline"
  }, [_c('table', {
    staticClass: "table table-hover table-striped table-bordered"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Email użytkownika")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Telefon użytkownika")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.user.phone))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Obecny pakiet")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.user.access.planDefinition.name) + "\n        ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Aktywność pakietu")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm._f("date")(_vm.user.access.startAt)) + " - " + _vm._s(_vm._f("date")(_vm.user.access.endAt)) + "\n          "), (_vm.user.access.isTrial) ? [_vm._v("(okres testowy)")] : _vm._e()], 2)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Zmień na pakiet")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlanDefinition),
      expression: "newPlanDefinition"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newPlanDefinition = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("-- wybierz pakiet --")]), _vm._v(" "), _vm._l((_vm.planDefinitions), function(plan) {
    return _c('option', {
      domProps: {
        "value": plan.id
      }
    }, [_vm._v(_vm._s(plan.name))])
  })], 2)])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Czy okres testowy")]), _vm._v(" "), _c('td', [_c('checkbox-input', {
    attrs: {
      "label": "Okres testowy"
    },
    model: {
      value: (_vm.trial),
      callback: function($$v) {
        _vm.trial = $$v
      },
      expression: "trial"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Na okres")]), _vm._v(" "), _c('td', [_c('date-picker', {
    model: {
      value: (_vm.from),
      callback: function($$v) {
        _vm.from = $$v
      },
      expression: "from"
    }
  }), _vm._v("\n          do\n          "), _c('date-picker', {
    model: {
      value: (_vm.to),
      callback: function($$v) {
        _vm.to = $$v
      },
      expression: "to"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('question-button', {
    staticClass: "btn btn-primary",
    attrs: {
      "question": "Czy na pewno zmienić pakiet temu użytkownikowi"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n            Zmień pakiet\n          ")])], 1)])])])])])
},staticRenderFns: []}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Kontrahenci")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('form-group', {
    attrs: {
      "label": "Treść o kontrahentach",
      "error": _vm.errors['producerList.content']
    }
  }, [_c('textarea-input', {
    attrs: {
      "rows": "10"
    },
    model: {
      value: (_vm.producerList.content),
      callback: function($$v) {
        _vm.producerList.content = $$v
      },
      expression: "producerList.content"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('submit-button', {
    staticClass: "pull-right",
    attrs: {
      "submitting": _vm.submitting
    }
  }), _vm._v(" "), _c('br'), _c('br')], 1), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": _vm.getRouteToAdd
    }
  }, [_vm._v("Dodaj kontrahenta")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.producers), function(producer, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(producer.name))]), _vm._v(" "), _c('td', [_c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index !== 0),
        expression: "index !== 0"
      }],
      staticClass: "btn btn-default btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.moveUp(producer)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-chevron-up"
    })]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index !== _vm.producers.length - 1),
        expression: "index !== producers.length - 1"
      }],
      staticClass: "btn btn-default btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.moveDown(producer)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-chevron-down"
    })])]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-default btn-sm",
      attrs: {
        "to": _vm.getRouteToEdit(producer)
      }
    }, [_vm._v("Edytuj")]), _vm._v(" "), _c('question-button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "question": "Czy na pewno usunąć tego producenta?"
      },
      on: {
        "click": function($event) {
          _vm.remove(producer)
        }
      }
    }, [_vm._v("\n          Usuń\n        ")])], 1)])
  }))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nazwa")]), _vm._v(" "), _c('th', [_vm._v("Pozycja")]), _vm._v(" "), _c('th')])])
}]}

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Użytkownicy (" + _vm._s(_vm.users.length) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Wyszukaj email...",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packet),
      expression: "packet"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.packet = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- pakiet --")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "free"
    }
  }, [_vm._v("Free")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "premium"
    }
  }, [_vm._v("Premium")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pro"
    }
  }, [_vm._v("Premium + SMS")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- typ konta --")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "buyer"
    }
  }, [_vm._v("Kupujący")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "seller"
    }
  }, [_vm._v("Sprzedający")])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover table-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(user) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.phone))]), _vm._v(" "), _c('td', [_c('address', [_vm._v("\n          " + _vm._s(user.address.name) + " "), _c('br'), _vm._v("\n          " + _vm._s(user.address.taxId) + " "), _c('br'), _vm._v("\n          " + _vm._s(user.address.streetAndNumber) + " "), _c('br'), _vm._v("\n          " + _vm._s(user.address.postalCode) + " "), _c('br'), _vm._v("\n          " + _vm._s(user.address.city) + "\n        ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(user.createdAt)))]), _vm._v(" "), _c('td', [_c('boolean-state', {
      attrs: {
        "state": user.enabled
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!user.enabled && !user.sending),
        expression: "!user.enabled && !user.sending"
      }],
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "title": "Wyślij link aktywacyjny ponownie"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.resendActivation(user)
        }
      }
    }, [_vm._v("\n          Ponów\n        ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.sending),
        expression: "user.sending"
      }]
    }, [_vm._v("wysyłam...")])], 1), _vm._v(" "), _c('td', [(user.access) ? [_vm._v("\n          " + _vm._s(_vm._f("access")(user.access.name)) + "\n        ")] : [_vm._v("Brak")]], 2), _vm._v(" "), _c('td', [(user.access) ? [_c('boolean-state', {
      attrs: {
        "state": user.access.isTrial
      }
    })] : [_vm._v("Brak")]], 2), _vm._v(" "), _c('td', [_c('boolean-state', {
      attrs: {
        "state": _vm.nullToBool(user.notificationSettings)
      }
    })], 1), _vm._v(" "), _c('td', [(user.access) ? [_vm._v("\n        " + _vm._s(_vm._f("date")(user.access.endAt)) + "\n        ")] : [_vm._v("Brak")]], 2), _vm._v(" "), _c('td', [_vm._v("\n        " + _vm._s(_vm._f("type")(user.type)) + "\n      ")]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": _vm.getRouteToChangePackage(user)
      }
    }, [_vm._v("Zmień pakiet")])], 1)])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Telefon")]), _vm._v(" "), _c('th', [_vm._v("Dane do faktury")]), _vm._v(" "), _c('th', [_vm._v("Utworzenie konta")]), _vm._v(" "), _c('th', [_vm._v("Aktywowany")]), _vm._v(" "), _c('th', [_vm._v("Pakiet")]), _vm._v(" "), _c('th', [_vm._v("Okres próbny")]), _vm._v(" "), _c('th', [_vm._v("Wybrane powiadomienia")]), _vm._v(" "), _c('th', [_vm._v("Zakończenie pakietu")]), _vm._v(" "), _c('th', [_vm._v("Typ konta")]), _vm._v(" "), _c('th')])])
}]}

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-pills nav-stacked nav-bordered row"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "role": "presentation",
      "to": {
        name: 'Homepage'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Strona główna")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "role": "presentation",
      "to": _vm.recordsRoute
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Notowania")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "role": "presentation",
      "to": {
        name: 'Producers'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Kontrahenci")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "role": "presentation",
      "to": {
        name: 'Products'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Produkty")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "role": "presentation",
      "to": {
        name: 'Notices'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Ogłoszenia")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "role": "presentation",
      "to": {
        name: 'Regulations'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Regulamin")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "role": "presentation",
      "to": {
        name: 'PriceList'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Cennik")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "role": "presentation",
      "to": {
        name: 'Contact'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Kontakt")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "role": "presentation",
      "to": {
        name: 'Users'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Użytkownicy notowań")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "role": "presentation",
      "to": {
        name: 'Payments'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Płatności")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.form.config), function(group, legend) {
    return _c('fieldset', [_c('legend', [_vm._v(_vm._s(legend))]), _vm._v(" "), _vm._l((group), function(field, index) {
      return _c('form-group', {
        key: index,
        attrs: {
          "label": field.label,
          "label-col": 2,
          "control-col": 10,
          "error": _vm.errors[field.name]
        }
      }, [_c('text-input', {
        model: {
          value: (_vm.form.fields[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.form.fields, field.name, $$v)
          },
          expression: "form.fields[field.name]"
        }
      })], 1)
    })], 2)
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.submitting
    }
  }, [(_vm.submitting) ? [_vm._v("Zapisywanie")] : [_vm._v("Zapisz")]], 2)], 2)
},staticRenderFns: []}

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "well media-manager",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('h4', {
    staticClass: "pull-left"
  }, [_vm._v("Biblioteka plików")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.fetchData($event)
      }
    }
  }, [_vm._v("Odśwież")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', [_c('label', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChanged
    }
  })]), _vm._v(" "), (_vm.errors.file) ? _c('p', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.errors.file))]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fetching),
      expression: "fetching"
    }]
  }, [_vm._v("Ładowanie...")]), _vm._v(" "), (_vm.hasMedias) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.medias), function(media) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": media.filepath,
        "target": "_blank",
        "title": "Otwórz w nowym oknie"
      }
    }, [_c('img', {
      staticClass: "img",
      attrs: {
        "src": media.filepath,
        "height": "50"
      }
    })])]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(media.filename) + "\n        ")]), _vm._v(" "), _c('td', [(_vm.isSelected(media)) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "title": "Odznacz",
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.unSelect(media)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-check"
    })]) : _c('button', {
      staticClass: "btn btn-default btn-sm",
      attrs: {
        "title": "Wybierz",
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.select(media)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-unchecked"
    })]), _vm._v(" "), _c('question-button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "title": "Usuń z biblioteki",
        "type": "button",
        "question": "Czy na pewno usunąć plik z biblioteki?"
      },
      on: {
        "click": function($event) {
          _vm.remove(media)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-trash"
    })])], 1)])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.showEmptyMessage) ? _c('div', [_vm._v("\n    Brak plików\n  ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("Wybierz")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("Anuluj")])]), _vm._v(" "), (_vm.large) ? _c('large-media', {
    attrs: {
      "media": _vm.large
    },
    on: {
      "close": _vm.closeLarge
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "btn btn-info btn-large"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-upload"
  }), _vm._v(" Dodaj plik\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Miniatura")]), _vm._v(" "), _c('th', [_vm._v("Nazwa")]), _vm._v(" "), _c('th')])])
}]}

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Regulamin")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('form-group', {
    attrs: {
      "label": "Treść regulaminu",
      "error": _vm.errors['regulation.content']
    }
  }, [_c('textarea-input', {
    attrs: {
      "rows": "25"
    },
    model: {
      value: (_vm.regulation.content),
      callback: function($$v) {
        _vm.regulation.content = $$v
      },
      expression: "regulation.content"
    }
  })], 1), _vm._v(" "), _c('submit-button', {
    attrs: {
      "submitting": _vm.submitting
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("Dane ogólne")]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Nagłówek",
      "error": _vm.errors['header']
    }
  }, [_c('text-input', {
    model: {
      value: (_vm.notice.header),
      callback: function($$v) {
        _vm.notice.header = $$v
      },
      expression: "notice.header"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Treść",
      "error": _vm.errors['content']
    }
  }, [_c('textarea-input', {
    attrs: {
      "rows": "5"
    },
    model: {
      value: (_vm.notice.content),
      callback: function($$v) {
        _vm.notice.content = $$v
      },
      expression: "notice.content"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Data",
      "error": _vm.errors['date']
    }
  }, [_c('date-picker', {
    model: {
      value: (_vm.notice.date),
      callback: function($$v) {
        _vm.notice.date = $$v
      },
      expression: "notice.date"
    }
  })], 1)], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Zdjęcia")]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Zdjęcia",
      "error": _vm.errors['photos']
    }
  }, [_c('media-input', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.notice.photos),
      callback: function($$v) {
        _vm.notice.photos = $$v
      },
      expression: "notice.photos"
    }
  })], 1)], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Pliki")]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Pliki",
      "error": _vm.errors['files']
    }
  }, [_c('media-input', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.notice.files),
      callback: function($$v) {
        _vm.notice.files = $$v
      },
      expression: "notice.files"
    }
  })], 1)], 1), _vm._v(" "), _c('submit-button', {
    attrs: {
      "submitting": _vm.submitting
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "glyphicon glyphicon-plus-sign"
  })
},staticRenderFns: []}

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Ogłoszenia")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": _vm.getRouteToAdd
    }
  }, [_vm._v("Dodaj ogłoszenie")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.notices), function(notice, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(notice.header))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(notice.date)))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-default btn-sm",
      attrs: {
        "to": _vm.getRouteToEdit(notice)
      }
    }, [_vm._v("Edytuj")]), _vm._v(" "), _c('question-button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "question": "Czy na pewno usunąć to ogłoszenie?"
      },
      on: {
        "click": function($event) {
          _vm.remove(notice)
        }
      }
    }, [_vm._v("\n          Usuń\n        ")])], 1)])
  }))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nagłówek")]), _vm._v(" "), _c('th', [_vm._v("Data")]), _vm._v(" "), _c('th')])])
}]}

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Produkty")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-bottom": "20px"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Zapisz")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.products), function(product, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(product.variety))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(product.origin))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "0"
      }
    }, [_c('label', {
      staticStyle: {
        "display": "block",
        "cursor": "pointer",
        "padding": "10px",
        "margin-bottom": "0"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.featured),
        expression: "featured"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": _vm.disabled(product)
      },
      domProps: {
        "value": product.id,
        "checked": Array.isArray(_vm.featured) ? _vm._i(_vm.featured, product.id) > -1 : (_vm.featured)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.featured,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = product.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.featured = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.featured = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.featured = $$c
          }
        }
      }
    })])])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info"
  }, [_c('strong', [_vm._v("Informacja")]), _vm._v("\n    Maksymalnie można wyróżnić do 10 produktów\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nazwa")]), _vm._v(" "), _c('th', [_vm._v("Odmiana")]), _vm._v(" "), _c('th', [_vm._v("Pochodzenie")]), _vm._v(" "), _c('th', [_vm._v("Wyróżnienie")])])])
}]}

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBrowse),
      expression: "showBrowse"
    }],
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showMediaManager = true
      }
    }
  }, [_vm._v("\n    Wybierz\n  ")]), _vm._v(" "), _c('media-manager', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMediaManager),
      expression: "showMediaManager"
    }],
    attrs: {
      "selected": _vm.localValue
    },
    on: {
      "close": function($event) {
        _vm.showMediaManager = false
      },
      "select": _vm.onSelect,
      "unselect": _vm.onUnSelect
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showMediaManager),
      expression: "!showMediaManager"
    }],
    staticClass: "row"
  }, _vm._l((_vm.localValue), function(media, index) {
    return _c('media-item', {
      key: index,
      attrs: {
        "media": media
      },
      on: {
        "change": function($event) {
          _vm.showMediaManager = true
        },
        "delete": _vm.onDelete
      }
    })
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.change
    }
  })
},staticRenderFns: []}

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto",
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "width": "100%",
      "height": "20px",
      "background-color": "#ddd"
    }
  }, [_vm._v("\n    szukaj.\n  ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-hover"
  }, [_c('tbody', _vm._l((_vm.options), function(option) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(option.label))])])
  }))])])
},staticRenderFns: []}

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("Dane ogólne")]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Data obowiązywania",
      "error": _vm.errors['date']
    }
  }, [_c('date-picker', {
    model: {
      value: (_vm.priceList.date),
      callback: function($$v) {
        _vm.priceList.date = $$v
      },
      expression: "priceList.date"
    }
  })], 1)], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Dla sprzedających")]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Pozycje cennika"
    }
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('td', [_vm._v("Rodzaj pojazdu")]), _vm._v(" "), _c('td', [_vm._v("Cena")]), _vm._v(" "), _c('td')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.priceList.forSellers), function(item) {
    return _c('tr', [_c('td', [_c('text-input', {
      model: {
        value: (item.type),
        callback: function($$v) {
          item.type = $$v
        },
        expression: "item.type"
      }
    })], 1), _vm._v(" "), _c('td', [_c('text-input', {
      model: {
        value: (item.price),
        callback: function($$v) {
          item.price = $$v
        },
        expression: "item.price"
      }
    })], 1), _vm._v(" "), _c('td', [_c('question-button', {
      staticClass: "btn btn-danger",
      attrs: {
        "question": "Czy na pewno usunąć pozycję?"
      },
      on: {
        "click": function($event) {
          _vm.removePosition(_vm.priceList.forSellers, item)
        }
      }
    }, [_c('trash-icon'), _vm._v("\n                Usuń pozycję\n              ")], 1)], 1)])
  }))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addPosition(_vm.priceList.forSellers)
      }
    }
  }, [_vm._v("Dodaj pozycję")])])], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Dla kupujących")]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Pozycje cennika"
    }
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('td', [_vm._v("Rodzaj pojazdu")]), _vm._v(" "), _c('td', [_vm._v("Cena")]), _vm._v(" "), _c('td')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.priceList.forBuyers), function(item) {
    return _c('tr', [_c('td', [_c('text-input', {
      model: {
        value: (item.type),
        callback: function($$v) {
          item.type = $$v
        },
        expression: "item.type"
      }
    })], 1), _vm._v(" "), _c('td', [_c('text-input', {
      model: {
        value: (item.price),
        callback: function($$v) {
          item.price = $$v
        },
        expression: "item.price"
      }
    })], 1), _vm._v(" "), _c('td', [_c('question-button', {
      staticClass: "btn btn-danger",
      attrs: {
        "question": "Czy na pewno usunąć pozycję?"
      },
      on: {
        "click": function($event) {
          _vm.removePosition(_vm.priceList.forBuyers, item)
        }
      }
    }, [_c('trash-icon'), _vm._v("\n                Usuń pozycję\n              ")], 1)], 1)])
  }))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addPosition(_vm.priceList.forBuyers)
      }
    }
  }, [_vm._v("Dodaj pozycję")])])], 1), _vm._v(" "), _c('submit-button', {
    attrs: {
      "submitting": _vm.submitting
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[253]);


// WEBPACK FOOTER //
// static/js/app.f40913bbedf303a95e0f.js